/* Gentilissimo — tema betikleri (bağımlılık yok) */
(function () {
  'use strict';

  var T = window.theme || {};
  var routes = T.routes || {};
  var strings = T.strings || {};

  /* ------------------------------------------------------------------
     Yardımcılar
     ------------------------------------------------------------------ */
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }
  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }
  function storageGet(key, fallback) {
    try { var v = localStorage.getItem(key); return v ? JSON.parse(v) : fallback; } catch (e) { return fallback; }
  }
  function storageSet(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* gizli mod vb. */ }
  }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  function formatAmount(cents) {
    var format = T.moneyFormat || '{{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var type = match ? match[1] : 'amount';
    function fmt(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    switch (type) {
      case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
      case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
      case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
      case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
      case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
      default: return fmt(cents, 2, ',', '.');
    }
  }
  function formatMoney(cents) { return (T.moneyPrefix || '') + formatAmount(cents); }

  /* Basit odak tuzağı */
  var trapStack = [];
  function trapFocus(container) {
    var focusables = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
    function handler(e) {
      if (e.key !== 'Tab') return;
      var els = qsa(focusables, container).filter(function (el) { return el.offsetParent !== null && getComputedStyle(el).visibility !== 'hidden'; });
      if (!els.length) return;
      var first = els[0], last = els[els.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', handler);
    trapStack.push({ container: container, handler: handler, previous: document.activeElement });
  }
  function releaseFocus(container) {
    for (var i = trapStack.length - 1; i >= 0; i--) {
      if (trapStack[i].container === container) {
        container.removeEventListener('keydown', trapStack[i].handler);
        var prev = trapStack[i].previous;
        trapStack.splice(i, 1);
        if (prev && prev.focus) { try { prev.focus({ preventScroll: true }); } catch (e) { prev.focus(); } }
        return;
      }
    }
  }

  var openCount = 0;
  function lockBody() { openCount++; document.body.classList.add('is-locked'); }
  function unlockBody() { openCount = Math.max(0, openCount - 1); if (!openCount) document.body.classList.remove('is-locked'); }

  /* ------------------------------------------------------------------
     Çekmeceler (menü, sepet, filtre, hızlı ekle)
     ------------------------------------------------------------------ */
  function openDrawer(drawer, trigger) {
    if (!drawer || drawer.classList.contains('is-open')) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    drawer._trigger = trigger || null;
    lockBody();
    var panel = qs('[role="dialog"]', drawer) || drawer;
    trapFocus(panel);
    setTimeout(function () { panel.focus({ preventScroll: true }); }, 50);
  }
  function closeDrawer(drawer) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (drawer._trigger) drawer._trigger.setAttribute('aria-expanded', 'false');
    unlockBody();
    var panel = qs('[role="dialog"]', drawer) || drawer;
    releaseFocus(panel);
  }

  // Genel çekmece: data-drawer-open="kimlik" ile açılır, içindeki data-drawer-close ile kapanır (ör. taksit tablosu)
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var target = document.getElementById(opener.getAttribute('data-drawer-open'));
      if (target) { e.preventDefault(); openDrawer(target, opener); }
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) closeDrawer(closer.closest('.drawer'));
  });

  // Aynı name'li açılır bölümlerden yalnız biri açık kalır (name desteği olmayan tarayıcılar için)
  document.addEventListener('toggle', function (e) {
    var el = e.target;
    if (!el || el.tagName !== 'DETAILS' || !el.open || !el.getAttribute('name')) return;
    qsa('details[name="' + el.getAttribute('name') + '"]').forEach(function (d) { if (d !== el && d.open) d.open = false; });
  }, true);

  // Formda eksik alan kapalı bir bölümdeyse gönderirken o bölüm açılır (yoksa tarayıcı alana gidemez)
  var invalidBusy = false;
  document.addEventListener('invalid', function (e) {
    if (invalidBusy) return;
    var det = e.target.closest && e.target.closest('details');
    if (!det) return;
    invalidBusy = true;
    setTimeout(function () { invalidBusy = false; }, 0);
    var group = det.getAttribute('data-group');
    if (group) qsa('details[data-group="' + group + '"]').forEach(function (o) { if (o !== det) { o.open = false; o.classList.remove('is-closing'); } });
    if (!det.open) det.open = true;
  }, true);

  /* Açılır bölümler: açılış ve kapanış kısa, yumuşak bir yükseklik ve saydamlık geçişiyle olur (sitenin her yerinde).
     Aynı gruptakiler (name) birlikte çalışır: biri açılırken açık olan diğeri kapanır. Hareket azaltmayı seçenlerde
     tarayıcının kendi davranışı kalır. */
  var smoothDetails = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  function detailsBody(d) {
    var summary = d.querySelector(':scope > summary');
    return summary ? summary.nextElementSibling : null;
  }
  function animateDetails(d, body, from, to, done) {
    if (d._anim) { d._anim.cancel(); d._anim = null; }
    body.style.overflow = 'hidden';
    var anim = body.animate(
      [{ height: from + 'px', opacity: from > 0 ? 1 : 0 }, { height: to + 'px', opacity: to > 0 ? 1 : 0 }],
      { duration: 320, easing: 'cubic-bezier(.4, 0, .2, 1)', fill: 'forwards' }
    );
    d._anim = anim;
    anim.onfinish = function () {
      if (d._anim !== anim) return;
      d._anim = null;
      if (done) done();
      anim.cancel();
      body.style.overflow = '';
    };
  }
  function closeDetails(d) {
    var body = detailsBody(d);
    if (!d.open || !body) return;
    d.classList.add('is-closing');
    animateDetails(d, body, body.getBoundingClientRect().height, 0, function () {
      d.open = false;
      d.classList.remove('is-closing');
    });
  }
  function openDetails(d) {
    var body = detailsBody(d);
    if (!body) return;
    var group = d.getAttribute('data-group');
    if (group) {
      qsa('details[data-group="' + group + '"]').forEach(function (o) {
        if (o !== d && o.open && !o.classList.contains('is-closing')) closeDetails(o);
      });
    }
    var from = d.open ? body.getBoundingClientRect().height : 0;
    if (d._anim) { d._anim.cancel(); d._anim = null; }
    d.classList.remove('is-closing');
    d.open = true;
    animateDetails(d, body, from, body.getBoundingClientRect().height);
  }
  function initDetails(root) {
    if (!smoothDetails) return;
    qsa('details', root).forEach(function (d) {
      if (d._smooth) return;
      var summary = d.querySelector(':scope > summary');
      if (!summary || !detailsBody(d) || typeof summary.animate !== 'function') return;
      d._smooth = true;
      if (d.getAttribute('name')) { d.setAttribute('data-group', d.getAttribute('name')); d.removeAttribute('name'); }
      on(summary, 'click', function (e) {
        e.preventDefault();
        if (d.open && !d.classList.contains('is-closing')) closeDetails(d);
        else openDetails(d);
      });
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var search = qs('[data-search-overlay].is-open');
    if (search) { closeSearch(); return; }
    var open = qsa('.drawer.is-open');
    if (open.length) closeDrawer(open[open.length - 1]);
  });

  /* ------------------------------------------------------------------
     Header: aşağı kaydırınca gizle, yukarı kaydırınca kompakt göster
     ------------------------------------------------------------------ */
  function initHeader() {
    var header = qs('[data-header]');
    if (!header) return;
    var compact = header.getAttribute('data-compact') === 'true';
    var lastY = window.scrollY;
    var ticking = false;
    function update() {
      var y = window.scrollY;
      var h = header.offsetHeight;
      if (y <= 10) {
        header.classList.remove('is-hidden', 'is-compact');
      } else if (y > lastY && y > h) {
        header.classList.add('is-hidden');
      } else if (y < lastY - 4) {
        if (compact) {
          header.classList.remove('is-hidden');
          header.classList.add('is-compact');
        } else if (y < h) {
          header.classList.remove('is-hidden');
        }
      }
      lastY = y;
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    // Sayfa aşağıda açılırsa (yenileme, geri dönüş) şeffaf başlık yazının üstünde kalmasın
    if (lastY > header.offsetHeight) header.classList.add('is-hidden');
  }

  /* ------------------------------------------------------------------
     Menü çekmecesi
     ------------------------------------------------------------------ */
  function initMenu() {
    var drawer = qs('[data-menu-drawer]');
    if (!drawer) return;
    qsa('[data-menu-open]').forEach(function (btn) {
      on(btn, 'click', function () {
        openDrawer(drawer, btn);
        // Hizmetler kartlarının görselleri panel açılmadan yüklensin
        qsa('[data-panel-cards] img[loading="lazy"]', drawer).forEach(function (img) { img.loading = 'eager'; });
      });
    });
    qsa('[data-menu-close]', drawer).forEach(function (btn) {
      on(btn, 'click', function () { closeDrawer(drawer); });
    });
    var toggles = qsa('[data-submenu-toggle]', drawer);
    var subTimer = null;
    // Alt paneller çekmeceyle aynı .3s geçişle kayarak açılır ve kapanır (masaüstünde ana menünün arkasından, telefonda
    // sağdan). Kapanırken panel kayma bitince gizlenir; başka panele geçerken eskisi hemen gizlenir, yenisi kayarak gelir.
    function closeSubs(animate) {
      var open = qsa('[data-submenu]', drawer).filter(function (s) { return !s.hidden; });
      toggles.forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-expanded', 'false'); });
      drawer.classList.remove('has-sub');
      clearTimeout(subTimer);
      if (animate === true && open.length) {
        subTimer = setTimeout(function () { open.forEach(function (s) { s.hidden = true; }); }, 320);
      } else {
        open.forEach(function (s) { s.hidden = true; });
      }
    }
    toggles.forEach(function (btn) {
      on(btn, 'click', function () {
        var sub = document.getElementById(btn.getAttribute('data-submenu-toggle'));
        if (btn.classList.contains('is-active')) { closeSubs(true); return; }
        closeSubs();
        if (!sub) return;
        sub.hidden = false;
        btn.classList.add('is-active');
        btn.setAttribute('aria-expanded', 'true');
        // Panel önce başlangıç konumunda çizilir, sonra sınıf eklenir; böylece kayma her seferinde çalışır
        void sub.offsetWidth;
        drawer.classList.add('has-sub');
      });
    });
    qsa('[data-submenu-back]', drawer).forEach(function (btn) { on(btn, 'click', function () { closeSubs(true); }); });

    // Dil paneli: en alttaki dil düğmesi açar, seçim yapılınca Shopify'ın dil formu gönderilir
    var langPanel = qs('[data-locale-panel]', drawer);
    var langOpen = qs('[data-locale-open]', drawer);
    var langTimer = null;
    function closeLang(animate) {
      if (!langPanel) return;
      drawer.classList.remove('has-lang');
      clearTimeout(langTimer);
      if (animate === true && !langPanel.hidden) langTimer = setTimeout(function () { langPanel.hidden = true; }, 320);
      else langPanel.hidden = true;
      if (langOpen) langOpen.setAttribute('aria-expanded', 'false');
    }
    if (langPanel && langOpen) {
      on(langOpen, 'click', function () {
        clearTimeout(langTimer);
        langPanel.hidden = false;
        langOpen.setAttribute('aria-expanded', 'true');
        void langPanel.offsetWidth;
        drawer.classList.add('has-lang');
        var checked = qs('input:checked', langPanel);
        if (checked) setTimeout(function () { checked.focus({ preventScroll: true }); }, 50);
      });
      qsa('[data-locale-back]', langPanel).forEach(function (btn) {
        on(btn, 'click', function () { closeLang(true); langOpen.focus({ preventScroll: true }); });
      });
      qsa('[data-locale-radio]', langPanel).forEach(function (radio) {
        on(radio, 'change', function () { if (radio.checked && radio.form) radio.form.submit(); });
      });
    }

    on(drawer, 'transitionend', function (e) {
      if (e.target === qs('.menu-drawer__panel', drawer) && !drawer.classList.contains('is-open')) { closeSubs(); closeLang(); }
    });
  }

  /* ------------------------------------------------------------------
     Arama ekranı + anlık arama
     ------------------------------------------------------------------ */
  var HISTORY_KEY = 'g-search-history';
  function closeSearch() {
    var overlay = qs('[data-search-overlay]');
    if (!overlay || !overlay.classList.contains('is-open')) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    unlockBody();
    releaseFocus(overlay);
  }
  function initSearch() {
    var overlay = qs('[data-search-overlay]');
    if (!overlay) return;
    var input = qs('[data-search-input]', overlay);
    var form = qs('[data-search-form]', overlay);
    var live = qs('[data-search-live]', overlay);
    var def = qs('[data-search-default]', overlay);
    var allLink = qs('[data-search-all]', overlay);
    var historyWrap = qs('[data-search-history]', overlay);
    var historyList = qs('[data-search-history-list]', overlay);
    var controller = null;
    // Dokunmatik: sonuçlar parmakla kaydırılınca klavye kapanır, sonuçlar görünür
    on(overlay, 'touchmove', function (e) {
      if (input && document.activeElement === input && !(form && form.contains(e.target))) input.blur();
    }, { passive: true });

    function renderHistory() {
      var items = storageGet(HISTORY_KEY, []);
      if (!historyWrap || !historyList) return;
      historyList.innerHTML = '';
      items.slice(0, 5).forEach(function (term) {
        var a = document.createElement('a');
        a.href = routes.search + '?q=' + encodeURIComponent(term) + '&type=product&options%5Bprefix%5D=last';
        a.textContent = term;
        historyList.appendChild(a);
      });
      historyWrap.hidden = items.length === 0;
    }
    function saveHistory(term) {
      term = (term || '').trim();
      if (term.length < 2) return;
      var items = storageGet(HISTORY_KEY, []).filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
      items.unshift(term);
      storageSet(HISTORY_KEY, items.slice(0, 8));
    }

    function open(trigger) {
      var menu = qs('[data-menu-drawer].is-open');
      if (menu) closeDrawer(menu);
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      lockBody();
      trapFocus(overlay);
      renderHistory();
      setTimeout(function () { input && input.focus(); }, 60);
    }
    qsa('[data-search-open]').forEach(function (btn) {
      on(btn, 'click', function (e) { e.preventDefault(); open(btn); });
    });
    qsa('[data-search-close]', overlay).forEach(function (btn) { on(btn, 'click', closeSearch); });
    on(form, 'submit', function () { saveHistory(input.value); });

    var search = debounce(function () {
      var term = input.value.trim();
      if (allLink) {
        allLink.href = term ? routes.search + '?q=' + encodeURIComponent(term) + '&type=product&options%5Bprefix%5D=last' : allLink.getAttribute('data-default-href');
      }
      if (term.length < 2) {
        live.hidden = true; live.innerHTML = '';
        def.hidden = false;
        return;
      }
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      overlay.classList.add('is-loading');
      var url = routes.predictiveSearch + '?q=' + encodeURIComponent(term) +
        '&resources%5Btype%5D=product&resources%5Blimit%5D=10&resources%5Boptions%5D%5Bunavailable_products%5D=last&section_id=predictive-search';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = parseHTML(html);
          var res = qs('[data-predictive-results]', doc);
          live.innerHTML = res ? res.innerHTML : '';
          live.hidden = false;
          def.hidden = true;
          overlay.classList.remove('is-loading');
          initCards(live);
          syncWishlistButtons(live);
        })
        .catch(function (err) { if (err.name !== 'AbortError') overlay.classList.remove('is-loading'); });
    }, 250);
    on(input, 'input', search);
  }

  /* ------------------------------------------------------------------
     Sepet
     ------------------------------------------------------------------ */
  var cartDrawer = null;
  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      el.setAttribute('data-count', count);
    });
  }
  function renderCartDrawer(html) {
    if (!cartDrawer || !html) return;
    var doc = parseHTML(html);
    var fresh = qs('[data-cart-drawer-inner]', doc);
    var current = qs('[data-cart-drawer-inner]', cartDrawer);
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }
  function refreshCart() {
    return fetch(routes.root.replace(/\/$/, '') + '/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) { renderCartDrawer(data['cart-drawer']); })
      .then(function () { return fetch(routes.cart + '.js').then(function (r) { return r.json(); }); })
      .then(function (cart) { updateCartCount(cart.item_count); return cart; });
  }
  function addToCart(variantId, quantity) {
    return fetch(routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }], sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          throw new Error(res.data.description || res.data.message || strings.cartError);
        }
        if (res.data.sections) renderCartDrawer(res.data.sections['cart-drawer']);
        return fetch(routes.cart + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) { updateCartCount(cart.item_count); return cart; });
  }
  function changeLine(line, quantity) {
    return fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || strings.cartError);
        if (data.sections) renderCartDrawer(data.sections['cart-drawer']);
        updateCartCount(data.item_count);
        return data;
      });
  }
  // Zorunlu onay kutuları (sepetteki sözleşme onayı, altbilgideki bülten izni) işaretlenmeden gönderilince: tarayıcı
  // balonu yerine kutunun altındaki satır görünür ve kutu ortaya kayar. Çekmece içeriği yenilense de çalışsın diye belge
  // düzeyinde dinlenir (invalid kabarmaz, capture).
  var IZIN_KUTUSU = '[data-cart-consent], [data-izin-kutusu]';
  var IZIN_HATA = '[data-cart-consent-hata], [data-izin-hata]';
  function initCartConsent() {
    document.addEventListener('invalid', function (e) {
      var box = e.target;
      if (!box.matches || !box.matches(IZIN_KUTUSU)) return;
      e.preventDefault();
      var label = box.closest('label');
      var hata = label && label.parentElement ? qs(IZIN_HATA, label.parentElement) : null;
      if (label) label.classList.add('is-hata');
      if (hata) hata.hidden = false;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (label && label.scrollIntoView) label.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
      try { box.focus({ preventScroll: true }); } catch (err) {}
    }, true);
    document.addEventListener('change', function (e) {
      var box = e.target;
      if (!box.matches || !box.matches(IZIN_KUTUSU) || !box.checked) return;
      var label = box.closest('label');
      var hata = label && label.parentElement ? qs(IZIN_HATA, label.parentElement) : null;
      if (label) label.classList.remove('is-hata');
      if (hata) hata.hidden = true;
    });
  }
  function initCart() {
    initCartConsent();
    cartDrawer = qs('[data-cart-drawer]');
    if (!cartDrawer) return;
    qsa('[data-cart-open]').forEach(function (btn) {
      on(btn, 'click', function (e) {
        if (document.body.classList.contains('template-cart')) return;
        e.preventDefault();
        openDrawer(cartDrawer, btn);
      });
    });
    on(cartDrawer, 'click', function (e) {
      if (e.target.closest('[data-cart-close]')) { closeDrawer(cartDrawer); return; }
      if (e.target.closest('[data-cart-continue]')) {
        // Mağazadaysak çekmeceyi kapat, başka sayfadaysak bağlantı çalışsın
        if (document.body.classList.contains('template-collection')) { e.preventDefault(); closeDrawer(cartDrawer); }
      }
    });
    bindCartLines(cartDrawer, false);
    var cartPage = qs('[data-cart-page]');
    if (cartPage) bindCartLines(cartPage, true);
    var note = qs('[data-cart-note]');
    on(note, 'change', function () {
      fetch(routes.cartUpdate + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note.value })
      });
    });
    // Hediye notu: kutucukla açılır; kapatılınca not silinir. Not, sepet niteliği olarak hemen kaydedilir.
    var gift = qs('[data-cart-gift]');
    if (gift) {
      var giftToggle = qs('[data-cart-gift-toggle]', gift);
      var giftField = qs('[data-cart-gift-field]', gift);
      var giftNote = qs('[data-cart-gift-note]', gift);
      var saveGift = function () {
        fetch(routes.cartUpdate + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'Hediye Notu': giftToggle.checked ? giftNote.value.trim() : '' } })
        });
      };
      on(giftToggle, 'change', function () {
        giftField.hidden = !giftToggle.checked;
        if (giftToggle.checked) { giftNote.focus(); return; }
        giftNote.value = '';
        saveGift();
      });
      on(giftNote, 'change', saveGift);
    }
  }
  function bindCartLines(root, reloadPage) {
    function lineOf(el) {
      var item = el.closest('[data-cart-item]');
      return item ? parseInt(item.getAttribute('data-line'), 10) : null;
    }
    function done() { if (reloadPage) window.location.reload(); }
    // Hata (ör. stok sınırı): uyarı penceresi yerine kısa bildirim; adet kutusu sepetteki gerçek adede döner.
    // Shopify adedi stok sınırına çektiyse sepet sayfası, toplamlar da güncellensin diye bildirimden sonra yenilenir.
    function failFor(input) {
      var line = input ? lineOf(input) : null;
      return function (err) {
        toast(err.message || strings.cartError);
        refreshCart().then(function (cart) {
          var item = line && cart && cart.items ? cart.items[line - 1] : null;
          if (!input || !item) return;
          input.value = item.quantity;
          if (reloadPage && String(item.quantity) !== input.getAttribute('value')) setTimeout(function () { window.location.reload(); }, 2200);
        }).catch(function () {});
      };
    }
    on(root, 'click', function (e) {
      var change = e.target.closest('[data-qty-change]');
      var remove = e.target.closest('[data-cart-remove]');
      if (change) {
        var input = qs('[data-qty-input]', change.closest('[data-cart-item]'));
        var q = Math.max(0, parseInt(input.value, 10) + parseInt(change.getAttribute('data-qty-change'), 10));
        input.value = q;
        changeLine(lineOf(change), q).then(done).catch(failFor(input));
      } else if (remove) {
        changeLine(lineOf(remove), 0).then(done).catch(failFor(null));
      }
    });
    on(root, 'change', function (e) {
      var input = e.target.closest('[data-qty-input]');
      if (!input) return;
      changeLine(lineOf(input), Math.max(0, parseInt(input.value, 10) || 0)).then(done).catch(failFor(input));
    });
  }

  (function guardRanges() {
    on(document, 'pointerdown', function (e) {
      var r = e.target;
      if (e.pointerType !== 'touch' || !r.matches || !r.matches('input[type="range"]')) return;
      r._onceki = r.value;
    }, true);
    on(document, 'pointercancel', function (e) {
      var r = e.target;
      if (!r.matches || !r.matches('input[type="range"]') || r._onceki == null) return;
      if (r.value !== r._onceki) { r.value = r._onceki; r.dispatchEvent(new Event('input', { bubbles: true })); r.dispatchEvent(new Event('change', { bubbles: true })); }
      r._onceki = null;
    }, true);
    on(document, 'pointerup', function (e) { if (e.target && 'value' in e.target) e.target._onceki = null; }, true);
  })();

  function toast(message) {
    var el = qs('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 2400);
  }

  /* ------------------------------------------------------------------
     Favoriler (tarayıcıda saklanır)
     ------------------------------------------------------------------ */
  var WISH_KEY = 'g-wishlist';
  function getWishlist() { return storageGet(WISH_KEY, []); }
  function syncWishlistButtons(root) {
    var list = getWishlist();
    qsa('[data-wishlist-toggle]', root).forEach(function (btn) {
      var active = list.indexOf(btn.getAttribute('data-wishlist-toggle')) > -1;
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? strings.wishlistRemove : strings.wishlistAdd);
    });
  }
  function initWishlist() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      var handle = btn.getAttribute('data-wishlist-toggle');
      var list = getWishlist();
      var idx = list.indexOf(handle);
      if (idx > -1) { list.splice(idx, 1); toast(strings.wishlistRemove); }
      else { list.unshift(handle); toast(strings.wishlistAdd); }
      storageSet(WISH_KEY, list.slice(0, 60));
      syncWishlistButtons(document);
      var page = qs('[data-wishlist-page]');
      if (page && idx > -1) {
        var card = btn.closest('[data-card]');
        if (card) card.remove();
        var grid = qs('[data-wishlist-grid]', page);
        if (grid && !grid.children.length) qs('[data-wishlist-empty]', page).hidden = false;
      }
    });
    syncWishlistButtons(document);

    var page = qs('[data-wishlist-page]');
    if (!page) return;
    var grid = qs('[data-wishlist-grid]', page);
    var empty = qs('[data-wishlist-empty]', page);
    var handles = getWishlist();
    if (!handles.length) { empty.hidden = false; return; }
    Promise.all(handles.map(function (h) {
      return fetch(routes.products + '/' + encodeURIComponent(h) + '?section_id=wishlist-card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (htmls) {
      htmls.forEach(function (html) {
        if (!html) return;
        var doc = parseHTML(html);
        var card = qs('[data-card]', doc);
        if (card) grid.appendChild(card);
      });
      if (!grid.children.length) empty.hidden = false;
      initCards(grid);
      syncWishlistButtons(grid);
    });
  }

  /* ------------------------------------------------------------------
     Ürün kartları: renk kutusuyla görsel değiştirme
     ------------------------------------------------------------------ */
  function initCards(root) {
    qsa('[data-card]', root).forEach(function (card) {
      if (card._init) return;
      card._init = true;
      var img = qs('[data-card-img]', card) || qs('.card__img', card);
      var links = qsa('[data-card-link]', card);
      var track = qs('[data-card-track]', card);
      var gallery = track ? cardGallery(card, track) : null;
      var colorText = qs('[data-card-color]', card);
      var swatches = qsa('.swatch', card);
      function apply(sw) {
        swatches.forEach(function (s) {
          s.classList.toggle('is-active', s === sw);
          if (s.hasAttribute('aria-pressed')) s.setAttribute('aria-pressed', s === sw ? 'true' : 'false');
        });
        var color = sw.getAttribute('title') || '';
        if (gallery) gallery.show(color);
        else if (img && sw.getAttribute('data-swatch-img')) {
          img.setAttribute('src', sw.getAttribute('data-swatch-img'));
          if (sw.getAttribute('data-swatch-srcset')) img.setAttribute('srcset', sw.getAttribute('data-swatch-srcset'));
        }
        var url = sw.getAttribute('data-swatch-url');
        if (url) links.forEach(function (a) { a.setAttribute('href', url); });
        if (colorText) colorText.textContent = color;
        card.setAttribute('data-selected-color', color);
        filterSizes();
      }

      // Hızlı ekle (eski Gentilissimo düzeni): + görselin altında seçili rengin bedenlerini açar, bedene basınca sepete ekler
      var quick = qs('[data-card-quick]', card);
      var sizePanel = qs('[data-card-sizes]', card);
      var sizeBtns = sizePanel ? qsa('[data-variant-id]', sizePanel) : [];
      function filterSizes() {
        var color = card.getAttribute('data-selected-color') || '';
        sizeBtns.forEach(function (b) { var c = b.getAttribute('data-color'); b.hidden = !!c && c !== color; });
      }
      function setSizesOpen(open) {
        card.classList.toggle('is-sizes-open', open);
        if (quick) quick.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      function quickAdd(btn) {
        if (btn.disabled || btn.classList.contains('is-loading')) return;
        btn.classList.add('is-loading');
        addToCart(btn.getAttribute('data-variant-id'), 1).then(function () {
          btn.classList.remove('is-loading');
          setSizesOpen(false);
          openDrawer(cartDrawer);
        }).catch(function (err) {
          btn.classList.remove('is-loading');
          toast(err.message);
        });
      }
      if (quick && sizePanel) {
        on(quick, 'click', function (e) {
          e.preventDefault();
          filterSizes();
          if (sizePanel.hasAttribute('data-sizeless')) {
            var first = sizeBtns.filter(function (b) { return !b.hidden && !b.disabled; })[0];
            if (first) quickAdd(first);
            return;
          }
          setSizesOpen(!card.classList.contains('is-sizes-open'));
        });
        sizeBtns.forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); quickAdd(b); }); });
        // Fareyle: + üstüne gelince şerit açılır; + ile şerit dışına (görselin yukarısına ya da karttan) çıkınca kapanır.
        // Dokunmatikte + dokunuşla açılır, başka yere dokununca kapanır (aşağıdaki genel dinleyici).
        if (!sizePanel.hasAttribute('data-sizeless')) {
          on(quick, 'pointerenter', function (e) {
            if (e.pointerType !== 'mouse') return;
            filterSizes();
            setSizesOpen(true);
          });
          var leaveZone = function (e) {
            if (e.pointerType !== 'mouse') return;
            var to = e.relatedTarget;
            if (to && (quick.contains(to) || sizePanel.contains(to))) return;
            setSizesOpen(false);
          };
          on(quick, 'pointerleave', leaveZone);
          on(sizePanel, 'pointerleave', leaveZone);
        }
        on(card, 'pointerleave', function (e) { if (e.pointerType === 'mouse') setSizesOpen(false); });
        card._closeSizes = function () { setSizesOpen(false); };
      }
      // Koleksiyon renk filtresi: seçilen renklerden biri kartta varsa o renge, yoksa varsayılan renge geç
      card._pickColor = function (colors) {
        var pick = swatches.filter(function (s) { return colors.indexOf(s.getAttribute('title')) !== -1; })[0] ||
          swatches.filter(function (s) { return s.getAttribute('title') === card.getAttribute('data-default-color'); })[0];
        if (pick && !pick.classList.contains('is-active')) apply(pick);
      };
      swatches.forEach(function (sw) {
        on(sw, 'click', function (e) { e.preventDefault(); apply(sw); });
        on(sw, 'mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) apply(sw); });
      });
    });
  }

  // Açık beden şeridi: kartın dışına dokununca/tıklayınca kapanır
  document.addEventListener('click', function (e) {
    qsa('.card.is-sizes-open').forEach(function (c) { if (!c.contains(e.target) && c._closeSizes) c._closeSizes(); });
  });

  /* Büyük kart görselleri (Suitsupply): yana kaydırılır, masaüstünde oklarla geçilir. İlk görselden sonrakiler
     karta ilk dokunuşta / üzerine gelince yüklenir; renk seçilince yalnız o rengin görselleri kalır. */
  function cardGallery(card, track) {
    var slides = qsa('[data-card-slide]', track);
    var prev = qs('[data-card-prev]', card);
    var next = qs('[data-card-next]', card);
    var bar = qs('[data-card-progress]', card);
    var loaded = false;
    var ticking = false;
    function hydrate() {
      if (loaded) return;
      loaded = true;
      qsa('img[data-srcset]', track).forEach(function (im) {
        im.setAttribute('srcset', im.getAttribute('data-srcset'));
        im.setAttribute('src', im.getAttribute('data-src'));
        im.removeAttribute('data-srcset');
        im.removeAttribute('data-src');
      });
    }
    function update() {
      ticking = false;
      var count = slides.filter(function (sl) { return !sl.hidden; }).length;
      card.classList.toggle('is-single', count < 2);
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      // Dokunmatik konum çizgisi: 1/count genişlikte, kaydırma oranıyla ilerler
      if (bar) {
        bar.style.setProperty('--n', Math.max(count, 1));
        bar.style.setProperty('--p', max > 0 ? (Math.min(Math.max(track.scrollLeft / max, 0), 1) * (count - 1)).toFixed(3) : 0);
      }
    }
    function step(dir) {
      hydrate();
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      track.scrollBy({ left: dir * (track.clientWidth + gap), behavior: 'smooth' });
    }
    on(prev, 'click', function (e) { e.preventDefault(); step(-1); });
    on(next, 'click', function (e) { e.preventDefault(); step(1); });
    on(track, 'scroll', function () {
      hydrate();
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    on(card, 'pointerenter', function () { hydrate(); update(); });
    on(card, 'touchstart', hydrate, { passive: true });
    on(card, 'focusin', hydrate);
    update();
    return {
      show: function (color) {
        var has = slides.some(function (sl) { return sl.getAttribute('data-color') === color; });
        slides.forEach(function (sl) {
          var c = sl.getAttribute('data-color');
          sl.hidden = has && c !== '' && c !== color;
        });
        hydrate();
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = 0;
        track.style.scrollBehavior = '';
        update();
      }
    };
  }

  /* ------------------------------------------------------------------
     Hızlı ekle
     ------------------------------------------------------------------ */
  function initQuickAdd() {
    var modal = qs('[data-quick-add-modal]');
    if (!modal) return;
    var state = null;

    function optionValuesHtml(product, idx, selected) {
      var name = (product.options[idx].name || '').toLowerCase();
      var isColor = name === 'renk' || name === 'color' || name === 'colour';
      var html = '<div class="option-group"><div class="option-group__label">' + product.options[idx].name + '</div><div class="option-group__values">';
      product.options[idx].values.forEach(function (value) {
        var cls = 'option-size' + (value === selected ? ' is-selected' : '');
        var variant = product.variants.find(function (v) { return v.options[idx] === value; });
        if (isColor && variant && variant.featured_image) {
          html += '<button type="button" class="option-thumb' + (value === selected ? ' is-selected' : '') + '" data-q-index="' + idx + '" data-q-value="' + value.replace(/"/g, '&quot;') + '" title="' + value.replace(/"/g, '&quot;') + '"><img src="' + variant.featured_image.src + '&width=200" alt="' + value.replace(/"/g, '&quot;') + '"></button>';
        } else {
          html += '<button type="button" class="' + cls + '" data-q-index="' + idx + '" data-q-value="' + value.replace(/"/g, '&quot;') + '">' + value + '</button>';
        }
      });
      return html + '</div></div>';
    }
    function currentVariant() {
      return state.product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === state.selected[i]; });
      });
    }
    function render() {
      var p = state.product;
      var v = currentVariant();
      qs('[data-quick-title]', modal).textContent = p.title;
      qs('[data-quick-price]', modal).textContent = formatMoney(v ? v.price : p.price);
      var image = (v && v.featured_image && v.featured_image.src) || (p.featured_image || '');
      qs('[data-quick-media]', modal).innerHTML = image ? '<img src="' + image + (image.indexOf('?') > -1 ? '&' : '?') + 'width=400" alt="">' : '';
      var opts = '';
      if (!(p.variants.length === 1 && p.variants[0].title === 'Default Title')) {
        p.options.forEach(function (o, i) { opts += optionValuesHtml(p, i, state.selected[i]); });
      }
      qs('[data-quick-options]', modal).innerHTML = opts;
      // Seçili renkte tükenen bedenleri işaretle
      qsa('[data-q-value]', modal).forEach(function (btn) {
        var i = parseInt(btn.getAttribute('data-q-index'), 10);
        var val = btn.getAttribute('data-q-value');
        var test = state.selected.slice(); test[i] = val;
        var match = p.variants.find(function (x) { return x.options.every(function (o, k) { return o === test[k]; }); });
        btn.classList.toggle('is-unavailable', !match || !match.available);
      });
      var submit = qs('[data-quick-submit]', modal);
      submit.disabled = !v || !v.available;
      submit.textContent = v && v.available ? strings.addToCart : (v ? strings.soldOut : strings.unavailable);
      qs('[data-quick-error]', modal).textContent = '';
      qs('[data-quick-link]', modal).setAttribute('href', p.url + (v ? '?variant=' + v.id : ''));
    }
    on(modal, 'click', function (e) {
      if (e.target.closest('[data-quick-close]')) { closeDrawer(modal); return; }
      var btn = e.target.closest('[data-q-value]');
      if (btn) {
        state.selected[parseInt(btn.getAttribute('data-q-index'), 10)] = btn.getAttribute('data-q-value');
        render();
      }
    });
    on(qs('[data-quick-submit]', modal), 'click', function () {
      var v = currentVariant();
      if (!v) return;
      var submit = this;
      submit.classList.add('is-loading');
      addToCart(v.id, 1).then(function () {
        submit.classList.remove('is-loading');
        closeDrawer(modal);
        openDrawer(cartDrawer);
      }).catch(function (err) {
        submit.classList.remove('is-loading');
        qs('[data-quick-error]', modal).textContent = err.message;
      });
    });

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-quick-add]');
      if (!trigger) return;
      e.preventDefault();
      var handle = trigger.getAttribute('data-quick-add');
      var card = trigger.closest('[data-card]');
      var preferredColor = card ? card.getAttribute('data-selected-color') : '';
      fetch(routes.products + '/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) {
          var first = product.variants.find(function (v) { return v.available; }) || product.variants[0];
          if (product.variants.length === 1) {
            return addToCart(first.id, 1).then(function () { openDrawer(cartDrawer); });
          }
          var selected = first.options.slice();
          if (preferredColor) {
            product.options.forEach(function (o, i) {
              var n = (o.name || '').toLowerCase();
              if ((n === 'renk' || n === 'color') && o.values.indexOf(preferredColor) > -1) {
                selected[i] = preferredColor;
                var alt = product.variants.find(function (v) { return v.options[i] === preferredColor && v.available; });
                if (alt) selected = alt.options.slice();
              }
            });
          }
          // Beden seçimini kullanıcıya bırak: seçili beden boş başlar (renk dışında)
          state = { product: product, selected: selected };
          render();
          openDrawer(modal, trigger);
        })
        .catch(function () { window.location.href = routes.products + '/' + handle; });
    });
  }

  /* ------------------------------------------------------------------
     Ürün sayfası
     ------------------------------------------------------------------ */
  /* Gentilissimo — beden simülatörü vücut çizimi (bağımlılık yok).
     Boy ve kiloya göre önden erkek silueti; üzerinde kategoriye göre giysi (ceket / pantolon / üst) ve oturuş
     tercihine göre bolluk. Değerler yumuşakça (yay benzeri) yeni değere akar. */
  var FitFigure = (function () {
    var NS = 'http://www.w3.org/2000/svg';
    var K = 1.75;          // 1 cm = 1,75 birim
    var GROUND = 386;      // zemin çizgisi
    var CX = 96;           // gövde ekseni (sağda ölçü yazılarına yer kalsın)
    var EASE = { dar: 1.4, tam: 3.2, rahat: 5.6 };
  
    function r1(v) { return Math.round(v * 10) / 10; }
    // Catmull-Rom eğrisi → kübik Bézier (yumuşak çizgi, köşesiz)
    function curve(pts, closed) {
      var n = pts.length;
      if (n < 2) return '';
      function at(i) { return closed ? pts[(i + n) % n] : pts[Math.max(0, Math.min(n - 1, i))]; }
      var d = 'M' + r1(pts[0][0]) + ' ' + r1(pts[0][1]);
      var segs = closed ? n : n - 1;
      for (var i = 0; i < segs; i++) {
        var p0 = at(i - 1), p1 = at(i), p2 = at(i + 1), p3 = at(i + 2);
        var t = 1 / 6;
        d += 'C' + r1(p1[0] + (p2[0] - p0[0]) * t) + ' ' + r1(p1[1] + (p2[1] - p0[1]) * t) + ' ' +
          r1(p2[0] - (p3[0] - p1[0]) * t) + ' ' + r1(p2[1] - (p3[1] - p1[1]) * t) + ' ' + r1(p2[0]) + ' ' + r1(p2[1]);
      }
      return closed ? d + 'Z' : d;
    }
    function mirror(pts) { return pts.map(function (p) { return [2 * CX - p[0], p[1]]; }).reverse(); }
  
    // Boy (cm) ve kilodan (kg) gövde ölçüleri (birim cinsinden yarım genişlikler ve yükseklik çizgileri)
    function geometry(h, w) {
      var H = K * h;
      var top = GROUND - H;
      var bmi = w / Math.pow(h / 100, 2);
      var f = Math.max(0.72, Math.min(1.75, bmi / 23));
      var r = h / 180;
      var g = {
        H: H, top: top, f: f,
        y: {
          headC: top + H * 0.064, neckTop: top + H * 0.118, neckBase: top + H * 0.152, shoulder: top + H * 0.182,
          chest: top + H * 0.262, waist: top + H * 0.405, hip: top + H * 0.492, crotch: top + H * 0.518,
          knee: top + H * 0.728, calf: top + H * 0.80, ankle: top + H * 0.958,
          elbow: top + H * 0.39, wrist: top + H * 0.518, hand: top + H * 0.578
        },
        headRx: 7.5 * K * Math.pow(r, 0.25), headRy: H * 0.064,
        neck: 5.6 * K * Math.pow(f, 0.4),
        shoulder: 20.5 * K * Math.pow(r, 0.5) * Math.pow(f, 0.2),
        chest: 16.2 * K * Math.pow(r, 0.4) * Math.pow(f, 0.6),
        waist: 14 * K * Math.pow(r, 0.35) * Math.pow(f, 1.0),
        hip: 16.4 * K * Math.pow(r, 0.4) * Math.pow(f, 0.62),
        knee: 4.9 * K * Math.pow(f, 0.42),
        calf: 5.4 * K * Math.pow(f, 0.45),
        ankle: 3.3 * K * Math.pow(f, 0.22),
        arm: 4.4 * K * Math.pow(f, 0.5),
        forearm: 3.5 * K * Math.pow(f, 0.4),
        drift: H * 0.013
      };
      g.legC = g.hip * 0.5;
      return g;
    }
  
    function bodyPath(g) {
      var y = g.y, c = CX, L = g.legC;
      var right = [
        [c + g.neck, y.neckTop],
        [c + g.neck * 1.12, y.neckBase],
        [c + g.shoulder * 0.76, y.shoulder - g.H * 0.008],
        [c + g.shoulder, y.shoulder + g.H * 0.02],
        [c + g.chest + 1, y.chest],
        [c + (g.chest + g.waist) / 2 + 0.6, (y.chest + y.waist) / 2],
        [c + g.waist, y.waist],
        [c + g.hip, y.hip],
        [c + L + g.hip * 0.47, y.crotch + g.H * 0.04],
        [c + L + g.knee, y.knee],
        [c + L + g.calf, y.calf],
        [c + L + g.ankle, y.ankle],
        [c + L + g.ankle + 2.6, GROUND],
        [c + L - g.ankle - 0.6, GROUND],
        [c + L - g.ankle * 0.9, y.ankle],
        [c + L - g.calf * 0.82, y.calf],
        [c + L - g.knee * 0.95, y.knee],
        [c + 2.4, y.crotch + g.H * 0.022]
      ];
      var pts = right.concat([[c, y.crotch]], mirror(right));
      return curve(pts, true);
    }
  
    function armPts(g, side) {
      var y = g.y, s = g.shoulder, d = g.drift;
      var pts = [
        [s * 0.8, y.shoulder - g.H * 0.004],
        [s + g.arm * 0.62, y.shoulder + g.H * 0.032],
        [s + g.arm * 0.56 + d, y.elbow],
        [s + g.forearm * 0.52 + d * 2, y.wrist],
        [s + g.forearm * 0.42 + d * 2.25, y.hand],
        [s - g.forearm * 0.38 + d * 2.25, y.hand + g.H * 0.005],
        [s - g.forearm * 0.76 + d * 2, y.wrist],
        [s - g.arm * 0.86 + d, y.elbow],
        [g.chest + 0.4, y.chest + g.H * 0.022],
        [s * 0.9, y.shoulder + g.H * 0.022]
      ];
      return pts.map(function (p) { return [CX + side * p[0], p[1]]; });
    }
  
    // Giysi: ceket (kollu, yaka V'si, düğme), üst (kollu, yuvarlak yaka) ya da pantolon; e = bolluk (birim)
    function garment(g, system, e) {
      var y = g.y, c = CX, L = g.legC, d = g.drift, s = g.shoulder;
      var out = { shape: '', lines: '' };
      if (system === 'pantolon') {
        var yTop = y.waist + g.H * 0.006;
        var wHalf = g.waist + e;
        var hemY = y.ankle + g.H * 0.014;
        var right = [
          [c + wHalf * 0.5, yTop],
          [c + wHalf, yTop + 0.3],
          [c + wHalf + (g.hip + e - wHalf) * 0.45, yTop + (y.hip - yTop) * 0.5],
          [c + g.hip + e, y.hip],
          [c + L + g.knee + e * 0.85, y.knee],
          [c + L + g.ankle + e * 0.8 + 1.6, hemY - g.H * 0.025],
          [c + L + g.ankle + e * 0.8 + 1.6, hemY],
          [c + L, hemY + 0.2],
          [c + L - g.ankle - e * 0.8 - 1.6, hemY],
          [c + L - g.ankle - e * 0.8 - 1.6, hemY - g.H * 0.025],
          [c + L - g.knee - e * 0.65, y.knee],
          [c + 1.8, y.crotch + g.H * 0.03]
        ];
        out.shape = curve([[c, yTop]].concat(right, [[c, y.crotch + g.H * 0.024]], mirror(right)), true);
        var wb = y.waist + g.H * 0.024;
        out.lines = 'M' + r1(c - wHalf) + ' ' + r1(wb) + 'L' + r1(c + wHalf) + ' ' + r1(wb) +
          'M' + r1(c) + ' ' + r1(wb) + 'L' + r1(c) + ' ' + r1(y.crotch);
        return out;
      }
      var jacket = system !== 'ust' && system !== 'gomlek';
      var yHem = jacket ? y.crotch + g.H * 0.04 : y.hip + g.H * 0.022;
      var cuffY = y.wrist - g.H * 0.004;
      var hemHalf = Math.max(g.hip, g.chest * 0.98) + e;
      var collarX = c + g.neck * (jacket ? 1.34 : 1.2);
      var collarY = y.neckBase - g.H * (jacket ? 0.001 : 0.004);
      var tipX = c + s + (jacket ? 1.8 : 0.8);
      var tipY = y.shoulder + g.H * 0.006;
      var right2 = [
        [collarX, collarY],
        [collarX + (tipX - collarX) * 0.55, collarY + (tipY - collarY) * 0.62],
        [tipX, tipY],
        [c + s + g.arm * 0.62 + e * 0.55, y.shoulder + g.H * 0.042],
        [c + s + g.arm * 0.56 + d + e * 0.55, y.elbow],
        [c + s + g.forearm * 0.52 + d * 2 + e * 0.45, cuffY],
        [c + s - g.forearm * 0.76 + d * 2 - e * 0.25, cuffY],
        [c + s - g.arm * 0.86 + d - e * 0.25, y.elbow],
        [c + g.chest + e * 0.85, y.chest + g.H * 0.034],
        [c + g.waist + e * (jacket ? 1.05 : 1.15), y.waist],
        [c + hemHalf, yHem - g.H * 0.04],
        [c + hemHalf, yHem],
        [c + hemHalf * 0.5, yHem + g.H * 0.002]
      ];
      var neckDip = y.neckBase + g.H * (jacket ? 0.004 : 0.016);
      out.shape = curve(right2.concat([[c, yHem + g.H * 0.003]], mirror(right2), [[c, neckDip]]), true);
      if (jacket) {
        var vy = y.waist - g.H * 0.04;
        out.lines = 'M' + r1(collarX) + ' ' + r1(collarY) + 'L' + r1(c + 1) + ' ' + r1(vy) +
          'M' + r1(2 * c - collarX) + ' ' + r1(collarY) + 'L' + r1(c - 1) + ' ' + r1(vy) +
          'M' + r1(c) + ' ' + r1(vy) + 'L' + r1(c) + ' ' + r1(yHem);
      } else {
        var rib = yHem - g.H * 0.022;
        out.lines = 'M' + r1(c - hemHalf) + ' ' + r1(rib) + 'L' + r1(c + hemHalf) + ' ' + r1(rib);
      }
      return out;
    }
  
    function el(name, attrs, parent) {
      var n = document.createElementNS(NS, name);
      for (var k in attrs) n.setAttribute(k, attrs[k]);
      if (parent) parent.appendChild(n);
      return n;
    }
  
    /* svg: boş <svg viewBox="0 0 220 400">; opts.system: ceket | pantolon | ust | gomlek; opts.labels: {chest, waist, hip} */
    function create(svg, opts) {
      var system = opts.system || 'ceket';
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      svg.setAttribute('viewBox', '0 0 240 400');
      var gHeight = el('g', { 'class': 'gf-height' }, svg);
      var hLine = el('path', {}, gHeight);
      var hText = el('text', { x: 4, 'text-anchor': 'start' }, gHeight);
      el('path', { 'class': 'gf-ground', d: 'M18 ' + GROUND + 'H226' }, svg);
      var arms = el('path', { 'class': 'gf-body gf-arms' }, svg);
      var body = el('path', { 'class': 'gf-body' }, svg);
      var head = el('ellipse', { 'class': 'gf-body' }, svg);
      var gShape = el('path', { 'class': 'gf-garment' }, svg);
      var gLines = el('path', { 'class': 'gf-garment-lines' }, svg);
      var marks = el('g', { 'class': 'gf-marks' }, svg);
      var markRows = (system === 'pantolon' ? ['waist', 'hip'] : ['chest', 'waist']).map(function (key) {
        return { key: key, line: el('path', {}, marks), text: el('text', { x: 236, 'text-anchor': 'end' }, marks) };
      });
  
      var cur = null, target = null, raf = 0, labels = {}, labelNames = opts.labelNames || {};
      function draw(v) {
        var g = geometry(v.h, v.w);
        body.setAttribute('d', bodyPath(g));
        arms.setAttribute('d', curve(armPts(g, 1), true) + curve(armPts(g, -1), true));
        head.setAttribute('cx', CX); head.setAttribute('cy', r1(g.y.headC));
        head.setAttribute('rx', r1(g.headRx)); head.setAttribute('ry', r1(g.headRy));
        var gm = garment(g, system, v.e);
        gShape.setAttribute('d', gm.shape);
        gLines.setAttribute('d', gm.lines);
        hLine.setAttribute('d', 'M10 ' + r1(g.top) + 'V' + GROUND + 'M6 ' + r1(g.top) + 'H14M6 ' + GROUND + 'H14');
        hText.setAttribute('y', r1(g.top - 7));
        hText.textContent = Math.round(v.h) + ' cm';
        markRows.forEach(function (m) {
          var yy = m.key === 'chest' ? g.y.chest + g.H * 0.014 : (m.key === 'waist' ? g.y.waist : g.y.hip);
          var half = m.key === 'chest' ? g.chest : (m.key === 'waist' ? g.waist : g.hip);
          m.line.setAttribute('d', 'M' + r1(CX - half) + ' ' + r1(yy) + 'H' + r1(CX + half) + 'M' + r1(CX + half + 4) + ' ' + r1(yy) + 'H' + 170);
          m.text.setAttribute('y', r1(yy + 3.6));
          var val = labels[m.key];
          m.text.textContent = val ? (labelNames[m.key] || m.key) + ' \u2248 ' + Math.round(val) : '';
        });
      }
      function step() {
        raf = 0;
        var done = true;
        ['h', 'w', 'e'].forEach(function (k) {
          var dlt = target[k] - cur[k];
          if (Math.abs(dlt) > 0.02) { cur[k] += dlt * 0.18; done = false; } else { cur[k] = target[k]; }
        });
        draw(cur);
        if (!done) raf = requestAnimationFrame(step);
      }
      return {
        set: function (h, w, pref, newLabels) {
          target = { h: h, w: w, e: EASE[pref] || EASE.tam };
          if (newLabels) labels = newLabels;
          if (!cur || reduce) { cur = { h: target.h, w: target.w, e: target.e }; draw(cur); return; }
          if (!raf) raf = requestAnimationFrame(step);
        }
      };
    }
    return { create: create, geometry: geometry, curve: curve, bodyPath: bodyPath, armPts: armPts, CX: CX, GROUND: GROUND, K: K, EASE: EASE };
  })();
  // Özel Dikim simülatörü (assets/ozel-dikim.js) aynı vücut çizimini kullanır
  window.GntFigure = FitFigure;

  function initProduct() {
    var root = qs('[data-product]');
    if (!root) return;
    var dataEl = qs('[data-product-json]', root);
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var form = qs('[data-product-form]', root);
    var idInput = qs('[data-variant-id]', root);
    var addBtn = qs('[data-add-button]', root);
    var addLabel = qs('[data-add-label]', root);
    var errorEl = qs('[data-product-error]', root);
    var priceEl = qs('[data-product-price]', root);
    var groups = qsa('[data-option-index]', root);
    var colorIndex = data.colorIndex;
    var sizeIndex = typeof data.sizeIndex === 'number' ? data.sizeIndex : -1;
    var sizeDrawer = qs('[data-size-drawer]', root);
    var sizeGuide = qs('[data-size-guide]', root);
    var sizeLabel = qs('[data-size-label]', root);
    var sizeSelectBtn = qs('.size-row__select', root);
    var sizeGuideBtn = qs('.size-row__guide', root);
    var sizeDataEl = qs('[data-size-data]', root);
    var sizeData = null;
    try { sizeData = sizeDataEl ? JSON.parse(sizeDataEl.textContent) : null; } catch (err) { sizeData = null; }
    var sizeT = (sizeData && sizeData.t) || {};
    var sizeValues = sizeIndex > -1 ? qsa('[data-option-index="' + sizeIndex + '"] [data-option-value]', root).map(function (b) { return b.getAttribute('data-option-value'); }) : [];
    // Prada gibi: kullanıcı beden seçene kadar "Beden seçin" yazar; adreste varyant varsa ya da tek beden varsa seçili sayılır
    var sizeChosen = sizeIndex < 0 || sizeValues.length < 2 || /[?&]variant=/.test(window.location.search);
    var pendingAdd = false;
    var recSize = null;

    var current = data.variants.find(function (v) { return String(v.id) === String(idInput.value); }) || data.variants[0];
    var selected = current.options.slice();

    function findVariant(opts) {
      return data.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    // Son parçalar: varyantın gerçek stoğu 1–3 ise kaç parça kaldığı (stok takipte değilse 0 = yazılmaz)
    var stockT = data.stockT || {};
    var stockNote = qs('[data-stock-note]', root);
    function lowQty(v) {
      return v && v.available && typeof v.qty === 'number' && v.qty > 0 && v.qty <= (data.lowStock || 3) ? v.qty : 0;
    }
    function stockText(n, one, many) { return n === 1 ? (one || '') : (many || '').replace('__N__', n); }
    // Beden seçilince düğmenin altında "Bu bedenden son 2 parça"; bedensiz üründe "Son 2 parça"
    function updateStockNote() {
      if (!stockNote) return;
      var n = sizeChosen ? lowQty(current) : 0;
      stockNote.textContent = n ? (sizeIndex > -1 ? stockText(n, stockT.sizeOne, stockT.sizeMany) : stockText(n, stockT.one, stockT.many)) : '';
      stockNote.hidden = !n;
    }
    function updateAvailability() {
      groups.forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        qsa('[data-option-value]', group).forEach(function (btn) {
          var test = selected.slice();
          test[idx] = btn.getAttribute('data-option-value');
          var v = findVariant(test);
          var isSel = selected[idx] === btn.getAttribute('data-option-value');
          btn.classList.toggle('is-selected', isSel);
          btn.setAttribute('aria-checked', isSel ? 'true' : 'false');
          if (idx !== colorIndex) btn.classList.toggle('is-unavailable', !v || !v.available);
        });
        var label = qs('[data-option-selected]', group);
        if (label) label.textContent = selected[idx];
      });
      updateSizeUi();
    }
    // Beden paneli ve "Beden seçin" düğmesi: seçilmeden önce satırlar seçili görünmez; tükenen bedende "Tükendi",
    // simülatörün önerdiği bedende "Önerilen" yazar. Beden seçilmeden sepet düğmesi, rengin herhangi bir bedeni
    // stokta varsa etkin kalır (basınca beden paneli açılır).
    function updateSizeUi() {
      updateStockNote();
      if (sizeIndex < 0) return;
      qsa('[data-option-index="' + sizeIndex + '"] [data-option-value]', root).forEach(function (btn) {
        var val = btn.getAttribute('data-option-value');
        if (!sizeChosen) { btn.classList.remove('is-selected'); btn.setAttribute('aria-checked', 'false'); }
        var note = qs('[data-size-note]', btn);
        if (!note) return;
        var soldOut = btn.classList.contains('is-unavailable');
        var isRec = !soldOut && recSize === val;
        var test = selected.slice();
        test[sizeIndex] = val;
        var low = soldOut ? 0 : lowQty(findVariant(test));
        var parts = [];
        if (isRec) parts.push(sizeT.recommended || '');
        if (low) parts.push(stockText(low, stockT.one, stockT.many));
        note.textContent = soldOut ? (sizeT.soldOutShort || strings.soldOut || '') : parts.join(' · ');
        note.classList.toggle('is-rec', isRec);
        note.classList.toggle('is-low', !!low);
      });
      if (sizeLabel) sizeLabel.textContent = sizeChosen ? (sizeT.size || '') + ': ' + selected[sizeIndex] : (sizeT.chooseSize || sizeLabel.textContent);
      if (sizeSelectBtn) sizeSelectBtn.classList.toggle('is-chosen', sizeChosen);
      if (!sizeChosen) {
        var anyAvail = data.variants.some(function (v) { return v.available && (colorIndex < 0 || v.options[colorIndex] === selected[colorIndex]); });
        addBtn.disabled = !anyAvail;
        addLabel.textContent = anyAvail ? strings.addToCart : strings.soldOut;
      }
    }
    function updateGallery() {
      if (colorIndex < 0) return;
      var color = selected[colorIndex];
      qsa('[data-media]', root).forEach(function (m) {
        var c = m.getAttribute('data-color');
        m.hidden = !!c && c !== color;
      });
      buildDots();
    }
    // Taksit tablosu: vade farkı fiyata eklenir, eşit taksitlere bölünür (Liquid ile aynı hesap)
    function updateInstallments(price) {
      qsa('[data-inst-price]').forEach(function (el) { el.textContent = formatMoney(price); });
      qsa('[data-installment]').forEach(function (row) {
        var n = parseInt(row.getAttribute('data-installment'), 10) || 1;
        var rate = parseFloat(row.getAttribute('data-rate')) || 0;
        var total = Math.round(price * (1 + rate / 100));
        qs('[data-inst-monthly]', row).textContent = formatMoney(Math.round(total / n));
        qs('[data-inst-total]', row).textContent = formatMoney(total);
      });
    }

    // Sağ panel sabit kalsın: açık bölüm, panel ekrana sığacak yükseklikle sınırlanır (--acc-max), uzunsa kendi içinde kayar
    var infoWrap = qs('.product__info-wrap', root);
    function setAccordionCap() {
      if (!infoWrap) return;
      if (window.innerWidth < 1280) { infoWrap.style.removeProperty('--acc-max'); return; }
      var openH = qsa('[data-accordion][open] .accordion__content', root).reduce(function (sum, c) { return sum + c.offsetHeight; }, 0);
      var rest = infoWrap.scrollHeight - openH;
      infoWrap.style.setProperty('--acc-max', Math.max(120, window.innerHeight - rest) + 'px');
    }
    setAccordionCap();
    on(window, 'resize', debounce(setAccordionCap, 150));
    on(window, 'load', setAccordionCap);

    // Özel dikim ürünü (data-bespoke): fiyat ve sepet alanı yok, yalnız seçili renk güncellenir
    var bespoke = root.hasAttribute('data-bespoke');
    function render(variant, pushUrl) {
      current = variant;
      if (bespoke) {
        if (variant) idInput.value = variant.id;
        updateAvailability();
        return;
      }
      if (variant) {
        idInput.value = variant.id;
        var html = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
        }
        html += '<span class="price__current">' + formatMoney(variant.price) + '</span>';
        priceEl.innerHTML = '<span class="price' + (variant.compare_at_price > variant.price ? ' price--sale' : '') + '">' + html + '</span>';
        updateInstallments(variant.price);
        addBtn.disabled = !variant.available;
        addLabel.textContent = variant.available ? strings.addToCart : strings.soldOut;
        if (pushUrl && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      } else {
        addBtn.disabled = true;
        addLabel.textContent = strings.unavailable;
      }
      errorEl.textContent = '';
      updateAvailability();
    }

    groups.forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-option-index'), 10);
      on(group, 'click', function (e) {
        var btn = e.target.closest('[data-option-value]');
        if (!btn) return;
        selected[idx] = btn.getAttribute('data-option-value');
        var v = findVariant(selected);
        if (idx === colorIndex && (!v || !v.available)) {
          // Renk değişince aynı bedende stok yoksa ilk uygun bedene geç
          var alt = data.variants.find(function (x) { return x.options[colorIndex] === selected[colorIndex] && x.available; });
          if (alt) { selected = alt.options.slice(); v = alt; }
        }
        render(v, true);
        if (idx === sizeIndex) {
          sizeChosen = true;
          updateAvailability();
          closeDrawer(sizeDrawer);
          if (pendingAdd) { pendingAdd = false; addCurrent(); }
        }
        if (idx === colorIndex) {
          updateGallery();
          // Bu Parçayla Kombinleyin bölümü seçili rengin kombinine geçer
          document.dispatchEvent(new CustomEvent('urun:renk', { detail: { renk: selected[colorIndex] } }));
          if (window.innerWidth >= 1280) {
            var firstVisible = qsa('[data-gallery] [data-media]', root).find(function (m) { return !m.hidden; });
            if (firstVisible && firstVisible.getBoundingClientRect().top < 0) {
              window.scrollTo({ top: root.getBoundingClientRect().top + window.scrollY, behavior: 'smooth' });
            }
          }
        }
      });
    });

    function addCurrent() {
      if (!current || !current.available) return;
      addBtn.classList.add('is-loading');
      addToCart(current.id, 1).then(function () {
        addBtn.classList.remove('is-loading');
        openDrawer(cartDrawer);
      }).catch(function (err) {
        addBtn.classList.remove('is-loading');
        errorEl.textContent = err.message;
      });
    }
    on(form, 'submit', function (e) {
      e.preventDefault();
      // Beden seçilmeden sepete eklenirse beden paneli açılır; seçilince ürün sepete eklenir (Prada akışı)
      if (!sizeChosen && sizeDrawer) { pendingAdd = true; openDrawer(sizeDrawer, sizeSelectBtn); return; }
      addCurrent();
    });
    on(sizeSelectBtn, 'click', function () { pendingAdd = false; });
    on(sizeDrawer, 'click', function (e) { if (e.target.closest('[data-drawer-close]')) pendingAdd = false; });
    qsa('[data-size-guide-swap]', root).forEach(function (b) {
      on(b, 'click', function () { closeDrawer(sizeDrawer); openDrawer(sizeGuide, sizeGuideBtn); });
    });

    /* Beden simülatörü ("Bedenimi Bul"): boy ve kilo kaydırıcıları; kilo boya göre 180 cm'ye ölçeklenir
       (üst giyimde kilo × 180 / boy, pantolonda kilo × (180 / boy)²) ve beden tablosunun 180 cm kilo aralıklarının
       orta değerleri arasında yerleştirilir; boy bedeni
       değil kol/paça boyunu belirler. Pantolonda bel girilirse öneri doğrudan bele göre yapılır. Dar/tam/rahat tercihi
       öneriyi yarım beden kaydırır. Vücut çizimi değerlere göre canlı şekil alır, üzerinde kategorinin giysisi tercihe göre
       bolalır. Ürünün bedenleri dışında kalan ölçülerde en yakın beden ve kişiye özel dikim randevusu önerilir. Değerler
       yalnız bu tarayıcıda saklanır. */
    function initFitFinder() {
      if (!sizeGuide || !sizeData) return;
      var table = (sizeData.tables || {})[sizeData.system] || [];
      if (table.length < 2) return;
      var offered = (sizeData.sizes && sizeData.sizes.length) ? sizeData.sizes : sizeValues;
      var t = sizeT;
      var hIn = qs('[data-ff-height]', sizeGuide);
      var wIn = qs('[data-ff-weight]', sizeGuide);
      var bIn = qs('[data-ff-waist]', sizeGuide);
      var hOut = qs('[data-ff-hout]', sizeGuide);
      var wOut = qs('[data-ff-wout]', sizeGuide);
      var resEl = qs('[data-ff-result]', sizeGuide);
      var sizeOut = qs('[data-ff-size]', sizeGuide);
      var whyEl = qs('[data-ff-why]', sizeGuide);
      var altEl = qs('[data-ff-alt]', sizeGuide);
      var noteEl = qs('[data-ff-note]', sizeGuide);
      var pickBtn = qs('[data-ff-pick]', sizeGuide);
      var waBtn = qs('[data-ff-wa]', sizeGuide);
      var prefOutEl = qs('[data-ff-pref-out]', sizeGuide);
      var lastWa = null;
      var tableEl = qs('[data-size-table]', sizeGuide);
      var figEl = qs('[data-ff-figure]', sizeGuide);
      if (!hIn || !wIn) return;
      var figure = figEl ? FitFigure.create(figEl, { system: sizeData.system, labelNames: { chest: t.cols.g, waist: t.cols.b, hip: t.cols.k } }) : null;
      var STORE = 'gnt-beden';
      var OFFSET = { dar: -0.35, tam: 0, rahat: 0.55 };
      var lastPick = null;
      var chosenPref = null;
      var touched = false;
      var saveTimer = 0;

      function readStore() { try { return JSON.parse(window.localStorage.getItem(STORE) || '{}') || {}; } catch (err) { return {}; } }
      function writeStore(o) { try { window.localStorage.setItem(STORE, JSON.stringify(o)); } catch (err) { /* depolama kapalı */ } }
      function fill(str, map) { return String(str || '').replace(/__([A-Z]+)__/g, function (m, k) { return map[k] != null ? map[k] : m; }); }
      function esc(str) { return String(str).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
      function range(r) { return r ? r[0] + '–' + r[1] : '—'; }
      function waistValue() { var b = bIn ? parseInt(bIn.value, 10) : NaN; return b >= 60 && b <= 140 ? b : null; }
      function prefValue() { var c = qs('[data-ff-pref]:checked', sizeGuide); return c ? c.value : 'tam'; }

      function buildTable() {
        if (!tableEl) return;
        var cols = sizeData.system === 'pantolon' ? ['b', 'k', 'w'] : ['g', 'b', 'w'];
        var unit = { g: ' (cm)', b: ' (cm)', k: ' (cm)', w: '' };
        var rows = table.filter(function (r) { return offered.indexOf(r.s) > -1; });
        if (!rows.length) rows = table;
        var html = '<thead><tr><th scope="col">' + esc(t.cols.s) + '</th>' + cols.map(function (c) {
          return '<th scope="col">' + esc(t.cols[c]) + unit[c] + '</th>';
        }).join('') + '</tr></thead><tbody>';
        rows.forEach(function (r) {
          html += '<tr data-size-row="' + esc(r.s) + '"><th scope="row">' + esc(r.s) + '</th>' + cols.map(function (c) { return '<td>' + range(r[c]) + '</td>'; }).join('') + '</tr>';
        });
        tableEl.innerHTML = html + '</tbody>';
      }
      function markTable(size) {
        if (!tableEl) return;
        qsa('tr[data-size-row]', tableEl).forEach(function (tr) { tr.classList.toggle('is-rec', tr.getAttribute('data-size-row') === size); });
      }
      function mids(key) { return table.map(function (r) { return r[key] ? (r[key][0] + r[key][1]) / 2 : null; }); }
      // Değerin tablo satırlarının orta noktaları arasındaki konumu (0 = ilk beden); uçlarda doğrusal devam eder
      function position(val, key) {
        var m = mids(key);
        var n = m.length;
        if (val <= m[0]) return (val - m[0]) / (m[1] - m[0]);
        if (val >= m[n - 1]) return n - 1 + (val - m[n - 1]) / (m[n - 1] - m[n - 2]);
        for (var i = 0; i < n - 1; i++) {
          if (val <= m[i + 1]) return i + (val - m[i]) / (m[i + 1] - m[i]);
        }
        return n - 1;
      }
      // Konuma göre tahmini vücut ölçüsü (çizimdeki etiketler için)
      function measureAt(pos, key) {
        var m = mids(key);
        if (m.some(function (v) { return v == null; })) return null;
        var i = Math.max(0, Math.min(m.length - 2, Math.floor(pos)));
        return m[i] + (m[i + 1] - m[i]) * (pos - i);
      }
      function availableIn(size) {
        if (sizeIndex < 0) return true;
        var test = selected.slice();
        test[sizeIndex] = size;
        var v = findVariant(test);
        return !!(v && v.available);
      }
      // Tablo karşılaştırmasında kullanılan değer: 180 cm'ye ölçeklenmiş kilo ya da girilmişse bel
      function measure(h, w, waist) {
        if (sizeData.system === 'pantolon') {
          if (waist) return { val: waist, key: 'b' };
          // Bel, boy–kilo oranını (vücut kitle indeksi) izler: pantolonda kilo 180 cm'ye boyun karesiyle ölçeklenir.
          // Doğrusal ölçek uzun ve ince yapılıları büyük bedene itiyordu (195 cm / 83 kg, 44 giyen sahip → 46).
          return { val: w * (180 / h) * (180 / h), key: 'w' };
        }
        return { val: w * 180 / h, key: 'w' };
      }
      function basePosition(h, w, waist) {
        var m = measure(h, w, waist);
        return position(m.val, m.key);
      }
      // "Uygun beden yok" sınırı: kilo, ürünün en küçük bedeninin alt sınırından %8 hafif ya da en büyük bedeninin
      // üst sınırından %8 ağır olana kadar uçtaki beden önerilir (sahip: 195 cm, 70 kg → 50). Bel girildiyse bir beden payı kalır.
      var NONE_RATIO = 0.92;
      var NONE_TOL = 1;
      function limits(key, lo, hi) {
        var a = table[lo][key], b = table[hi][key];
        if (key === 'w' && a && b) return { lo: position(a[0] * NONE_RATIO, key), hi: position(b[1] / NONE_RATIO, key) };
        return { lo: lo - NONE_TOL, hi: hi + NONE_TOL };
      }
      function compute(h, w, pref, waist) {
        var m = measure(h, w, waist);
        var base = position(m.val, m.key);
        var autoFrom = null;
        var ok = null;
        var offIdx = offered.map(function (s) { return table.findIndex(function (r) { return r.s === s; }); }).filter(function (i) { return i > -1; });
        // Ölçüler ürünün bedenlerinden belirgin biçimde küçük ya da büyükse en yakın bedeni önermek yanıltır:
        // "uygun beden yok" denir ve özel dikime yönlendirilir. Sınırın içinde uçtaki beden "en yakın beden" notuyla,
        // aradaki eksik bedenlerde en yakını önerilir.
        if (offIdx.length) {
          var lim = limits(m.key, Math.min.apply(null, offIdx), Math.max.apply(null, offIdx));
          var fits = function (p) { var x = base + (OFFSET[p] || 0); return x >= lim.lo && x <= lim.hi; };
          ok = {};
          Object.keys(OFFSET).forEach(function (p) { ok[p] = fits(p); });
          if (!fits(pref)) {
            // Seçilen oturuşta beden yoksa, beden veren en yakın oturuşa geçilir (ör. ince yapıya en küçük beden rahat oturur)
            var other = Object.keys(OFFSET).filter(function (p) { return p !== pref && fits(p); }).sort(function (a, b) {
              return Math.abs(OFFSET[a] - OFFSET[pref]) - Math.abs(OFFSET[b] - OFFSET[pref]);
            })[0];
            if (!other) return { size: null, none: true, alt: null, altDir: 0, pref: pref, ok: ok };
            autoFrom = pref;
            pref = other;
          }
        }
        var raw = base + (OFFSET[pref] || 0);
        var idx = Math.max(0, Math.min(table.length - 1, Math.round(raw)));
        var best = idx;
        var outOfRange = false;
        if (offIdx.length && offIdx.indexOf(idx) < 0) {
          best = offIdx.reduce(function (a, b) { return Math.abs(b - raw) < Math.abs(a - raw) ? b : a; });
          outOfRange = true;
        }
        var alt = null;
        var altDir = 0;
        var d = raw - best;
        if (!outOfRange && Math.abs(d) > 0.3) {
          var j = best + (d > 0 ? 1 : -1);
          if (offIdx.indexOf(j) > -1) { alt = table[j].s; altDir = d > 0 ? 1 : -1; }
        }
        return { size: table[best].s, outOfRange: outOfRange, alt: alt, altDir: altDir, pref: pref, autoFrom: autoFrom, ok: ok };
      }
      // "Danışmana Danışın": ürün, renk, ölçüler, oturuş, önerilen ve sayfada seçili beden WhatsApp mesajı olarak hazırlanır
      function cap(str) { return str ? str.charAt(0).toLocaleUpperCase(document.documentElement.lang || 'tr') + str.slice(1) : ''; }
      function waText() {
        var s = lastWa;
        var color = colorIndex > -1 ? selected[colorIndex] : '';
        var v = findVariant(selected);
        var lines = [t.waIntro, (sizeData.product || '') + (color ? ' — ' + color : '')];
        if (s) {
          lines.push(fill(t.waBody, { H: s.h, W: s.w, FIT: cap((t.fit && t.fit[s.r.pref]) || s.r.pref) }) + (s.waist ? ' · ' + fill(t.waWaist, { B: s.waist }) : ''));
          lines.push(s.r.none ? fill(t.waNone, { RANGE: offered[0] + '–' + offered[offered.length - 1] }) : fill(t.waRec, { SIZE: s.r.size }));
        }
        if (sizeChosen && sizeIndex > -1 && sizeValues.length > 1) lines.push(fill(t.waChosen, { SIZE: selected[sizeIndex] }));
        lines.push(window.location.origin + window.location.pathname + (v ? '?variant=' + v.id : ''));
        return lines.filter(Boolean).join('\n');
      }
      function updateWa() {
        if (!waBtn) return;
        var base = waBtn.getAttribute('data-base') || waBtn.href.split('?')[0];
        waBtn.href = base + (base.indexOf('?') < 0 ? '?' : '&') + 'text=' + encodeURIComponent(waText());
      }
      // Bu ölçülerde beden çıkmayan oturuşlar kırmızıya boyanır ve seçilemez; altta kısa açıklama çıkar
      function markPrefs(ok) {
        var anyOut = false;
        qsa('[data-ff-pref]', sizeGuide).forEach(function (input) {
          var out = !!ok && ok[input.value] === false;
          var opt = input.closest('.fit-pref__opt');
          input.disabled = out;
          if (opt) {
            opt.classList.toggle('is-out', out);
            if (out) opt.title = t.prefOut || ''; else opt.removeAttribute('title');
          }
          if (out) anyOut = true;
        });
        if (prefOutEl) prefOutEl.hidden = !anyOut;
      }
      function showResult(h, w, pref, waist) {
        var r = compute(h, w, pref, waist);
        lastWa = { h: h, w: w, waist: waist, r: r };
        updateWa();
        recSize = r.size;
        lastPick = r.size;
        // Düğmeler gösterilen sonucun oturuşunu yansıtır; müşterinin kendi seçimi chosenPref'te kalır
        var prefRadio = qs('[data-ff-pref][value="' + r.pref + '"]', sizeGuide);
        if (prefRadio) prefRadio.checked = true;
        markPrefs(r.ok);
        whyEl.textContent = fill(t.why, { H: h, W: w, FIT: (t.fit && t.fit[r.pref]) || r.pref });
        var sizeLine = sizeOut.parentNode;
        sizeLine.classList.toggle('is-none', !!r.none);
        pickBtn.hidden = !!r.none;
        if (r.none) {
          sizeOut.textContent = t.noSize || '';
          altEl.hidden = true;
          var nn = esc(fill(t.noSizeNote, { RANGE: offered[0] + '–' + offered[offered.length - 1] })) +
            ' <a href="' + esc(sizeData.appointmentUrl || '/pages/randevu') + '">' + esc(t.appointment) + '</a>';
          noteEl.innerHTML = nn;
          noteEl.hidden = false;
          resEl.hidden = false;
          markTable(null);
          updateSizeUi();
          return r;
        }
        sizeOut.textContent = r.size;
        if (r.alt) {
          altEl.textContent = fill(r.altDir > 0 ? t.altUp : t.altDown, { SIZE: r.alt });
          altEl.hidden = false;
        } else {
          altEl.hidden = true;
        }
        var avail = availableIn(r.size);
        pickBtn.textContent = fill(t.pick, { SIZE: r.size });
        pickBtn.disabled = !avail;
        var note = '';
        if (r.autoFrom && t.autoFit) note = esc(fill(t.autoFit, { FROM: (t.fit && t.fit[r.autoFrom]) || r.autoFrom, TO: (t.fit && t.fit[r.pref]) || r.pref }));
        if (!avail) note += (note ? ' ' : '') + esc(fill(t.soldOut, { SIZE: r.size }));
        if (r.outOfRange) {
          // Oturuş kendiliğinden değiştiyse açıklama zaten yazıldı; yalnız Özel Dikim bağlantısı eklenir
          if (!r.autoFrom) note += (note ? ' ' : '') + esc(fill(t.outOfRange, { RANGE: offered[0] + '–' + offered[offered.length - 1], SIZE: r.size }));
          note += ' <a href="' + esc(sizeData.appointmentUrl || '/pages/randevu') + '">' + esc(t.appointment) + '</a>';
        }
        if ((h >= 192 || h <= 165) && t.lengthNote) note += (note ? ' ' : '') + esc(t.lengthNote);
        noteEl.innerHTML = note;
        noteEl.hidden = !note;
        resEl.hidden = false;
        markTable(r.size);
        updateSizeUi();
        return r;
      }
      function paintRange(input) {
        var min = parseFloat(input.min), max = parseFloat(input.max);
        input.style.setProperty('--p', ((parseFloat(input.value) - min) / (max - min) * 100) + '%');
      }
      function update(persist) {
        var h = parseInt(hIn.value, 10);
        var w = parseInt(wIn.value, 10);
        var pref = chosenPref || prefValue();
        var waist = waistValue();
        if (hOut) hOut.textContent = h;
        if (wOut) wOut.textContent = w;
        paintRange(hIn);
        paintRange(wIn);
        var pos = basePosition(h, w, waist);
        var meas = { chest: measureAt(pos, 'g'), waist: waist || measureAt(pos, 'b'), hip: measureAt(pos, 'k') };
        if (!touched) {
          if (figure) figure.set(h, w, pref, meas);
          return;
        }
        var r = showResult(h, w, pref, waist);
        if (figure) figure.set(h, w, r.pref || pref, meas);
        if (persist) {
          clearTimeout(saveTimer);
          saveTimer = setTimeout(function () {
            var st = readStore();
            st.h = h; st.w = w; st.pref = pref;
            if (sizeData.system === 'pantolon') st.b = waist || null;
            st.rec = st.rec || {};
            st.rec[sizeData.system] = r.size;
            writeStore(st);
          }, 250);
        }
      }

      buildTable();
      var stored = readStore();
      if (stored.h >= 150 && stored.h <= 210 && stored.w >= 45 && stored.w <= 140) {
        hIn.value = stored.h;
        wIn.value = stored.w;
        if (bIn && stored.b) bIn.value = stored.b;
        if (stored.pref) {
          var radio = qs('[data-ff-pref][value="' + stored.pref + '"]', sizeGuide);
          if (radio) radio.checked = true;
        }
        touched = true;
      }
      chosenPref = prefValue();
      update(false);

      [hIn, wIn].forEach(function (input) {
        on(input, 'input', function () { touched = true; update(false); });
        on(input, 'change', function () { touched = true; update(true); });
      });
      on(bIn, 'input', function () { touched = true; update(true); });
      qsa('[data-ff-pref]', sizeGuide).forEach(function (r) { on(r, 'change', function () { chosenPref = r.value; touched = true; update(true); }); });
      // Sayfada beden ya da renk değişmiş olabilir: bağlantı tıklanırken yeniden kurulur
      on(waBtn, 'click', updateWa);
      on(pickBtn, 'click', function () {
        if (!lastPick) return;
        var btn = qsa('[data-option-index="' + sizeIndex + '"] [data-option-value]', root).find(function (b) { return b.getAttribute('data-option-value') === lastPick; });
        if (btn) btn.click();
        closeDrawer(sizeGuide);
      });
    }
    initFitFinder();

    /* Dikey noktalar (masaüstü) */
    var dotsWrap = qs('[data-dots]', root);
    var observer = null;
    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      if (observer) observer.disconnect();
      var images = qsa('[data-gallery] [data-media]', root).filter(function (m) { return !m.hidden; });
      if (images.length < 2) return;
      var dots = images.map(function (img, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', (i + 1) + '. görsel');
        if (i === 0) b.classList.add('is-active');
        on(b, 'click', function () { img.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
        dotsWrap.appendChild(b);
        return b;
      });
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var i = images.indexOf(entry.target);
              dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
            }
          });
        }, { rootMargin: '-45% 0px -45% 0px' });
        images.forEach(function (img) { observer.observe(img); });
      }
    }
    updateAvailability();
    buildDots();
    initMagnifier(root);
  }

  /* ------------------------------------------------------------------
     Ürün görseli büyüteci: görsele basınca yuvarlak bir büyüteç açılır ve imleci
     (dokunmatikte parmağı) izleyerek görseli 2 kat büyütür. Yeniden basınca,
     görselden çıkınca, sayfa kayınca ya da Esc ile kapanır.
     ------------------------------------------------------------------ */
  function initMagnifier(root) {
    var ZOOM = 2;
    var frames = qsa('.product__image', root).filter(function (f) { return qs('img', f); });
    if (!frames.length) return;
    var lens = document.createElement('div');
    lens.className = 'loupe';
    lens.setAttribute('aria-hidden', 'true');
    document.body.appendChild(lens);
    var active = null, img = null, touch = false, last = null, loaded = {};

    // srcset'teki en büyük adresi 2400 px genişlikle ister (büyütmede keskin kalsın)
    function hiRes(im) {
      var best = im.currentSrc || im.src, w = 0;
      (im.getAttribute('srcset') || '').split(',').forEach(function (c) {
        var p = c.trim().split(/\s+/), n = parseInt(p[1], 10);
        if (p[0] && n > w) { w = n; best = p[0]; }
      });
      if (/[?&]width=\d+/.test(best)) return best.replace(/([?&]width=)\d+/, '$12400');
      return best + (best.indexOf('?') > -1 ? '&' : '?') + 'width=2400';
    }
    function place(x, y) {
      var r = img.getBoundingClientRect();
      if (x < r.left || x > r.right || y < r.top || y > r.bottom) { close(); return; }
      // object-fit: cover — görselin çerçevede gerçekte kapladığı alan
      var nw = img.naturalWidth || r.width, nh = img.naturalHeight || r.height;
      var s = Math.max(r.width / nw, r.height / nh), rw = nw * s, rh = nh * s;
      var px = x - (r.left + (r.width - rw) / 2), py = y - (r.top + (r.height - rh) / 2);
      var size = lens.offsetWidth;
      lens.style.backgroundSize = (rw * ZOOM) + 'px ' + (rh * ZOOM) + 'px';
      lens.style.backgroundPosition = (size / 2 - px * ZOOM) + 'px ' + (size / 2 - py * ZOOM) + 'px';
      lens.style.left = x + 'px';
      // Dokunmatikte büyüteç parmağın üstünde durur, parmak altını örtmez
      lens.style.top = (touch ? y - size * 0.75 : y) + 'px';
      last = { x: x, y: y };
    }
    function open(frame, x, y) {
      close();
      active = frame;
      img = qs('img', frame);
      var src = hiRes(img);
      lens.style.backgroundImage = 'url("' + (loaded[src] ? src : (img.currentSrc || img.src)) + '")';
      if (!loaded[src]) {
        var pre = new Image();
        pre.onload = function () {
          loaded[src] = true;
          if (active === frame) lens.style.backgroundImage = 'url("' + src + '")';
        };
        pre.src = src;
      }
      frame.classList.add('is-zooming');
      lens.classList.toggle('loupe--touch', touch);
      place(x, y);
      if (active) lens.classList.add('is-visible');
    }
    function close() {
      if (!active) return;
      active.classList.remove('is-zooming');
      active = null;
      img = null;
      last = null;
      lens.classList.remove('is-visible');
    }
    frames.forEach(function (frame) {
      frame.classList.add('can-zoom');
      on(frame, 'pointerdown', function (e) { touch = e.pointerType !== 'mouse'; });
      on(frame, 'click', function (e) {
        if (active === frame) close();
        else open(frame, e.clientX, e.clientY);
      });
      on(frame, 'pointermove', function (e) { if (active === frame) place(e.clientX, e.clientY); });
      on(frame, 'pointerleave', function (e) { if (active === frame && e.pointerType === 'mouse') close(); });
    });
    on(window, 'scroll', function () {
      if (!active) return;
      if (touch) close();
      else if (last) place(last.x, last.y);
    }, { passive: true });
    on(window, 'resize', close);
    on(document, 'keydown', function (e) { if (e.key === 'Escape') close(); });
    on(document, 'click', function (e) { if (active && !active.contains(e.target)) close(); });
  }

  /* ------------------------------------------------------------------
     Öneriler ve kaydırıcılar
     ------------------------------------------------------------------ */
  function initCarousels(root) {
    qsa('[data-carousel]', root).forEach(function (c) {
      if (c._init) return;
      c._init = true;
      var track = qs('[data-carousel-track]', c);
      var prev = qs('[data-carousel-prev]', c);
      var next = qs('[data-carousel-next]', c);
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        var nav = qs('.carousel__nav', c);
        if (nav) nav.style.display = track.scrollWidth <= track.clientWidth + 2 ? 'none' : '';
      }
      on(prev, 'click', function () { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
      on(next, 'click', function () { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });
      on(track, 'scroll', debounce(update, 60), { passive: true });
      window.addEventListener('resize', debounce(update, 150));
      update();
    });
  }
  function initRecommendations() {
    qsa('[data-recommendations][data-url]').forEach(function (el) {
      var load = function () {
        fetch(el.getAttribute('data-url'))
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = parseHTML(html);
            var fresh = qs('[data-recommendations]', doc);
            if (fresh && qs('[data-card]', fresh)) {
              el.innerHTML = fresh.innerHTML;
              initCards(el);
              initCarousels(el);
              syncWishlistButtons(el);
            }
          })
          .catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { io.disconnect(); load(); }
        }, { rootMargin: '0px 0px 400px 0px' });
        io.observe(el);
      } else { load(); }
    });
  }

  /* ------------------------------------------------------------------
     Koleksiyon: sıralama ve filtre çekmecesi
     ------------------------------------------------------------------ */
  function initCollection() {
    var drawer = qs('[data-filter-drawer]');
    if (drawer) {
      qsa('[data-filter-open]').forEach(function (btn) { on(btn, 'click', function () { openDrawer(drawer, btn); }); });
      qsa('[data-filter-close]', drawer).forEach(function (btn) { on(btn, 'click', function () { closeDrawer(drawer); }); });
    }
    var form = qs('[data-filter-form]');
    var grid = qs('[data-filter-grid]');
    if (!form || !grid) return;
    var items = qsa('[data-filter-item]', grid);
    var empty = qs('[data-filter-empty]');
    var chips = qs('[data-filter-chips]');
    var badges = qsa('[data-filter-badge]');
    var result = qs('[data-filter-result]');
    var KEYS = ['tur', 'renk', 'beden'];

    // Beden kutucukları: önce sayılar küçükten büyüğe, sonra harfler (XS … 3XL)
    var sizeList = qs('[data-size-list]', form);
    if (sizeList) {
      var ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', '3XL', '4XL'];
      var rank = function (v) {
        var n = parseFloat(v);
        if (!isNaN(n)) return n;
        var i = ORDER.indexOf(String(v).toUpperCase());
        return i === -1 ? 9000 : 1000 + i;
      };
      qsa('.filter-pill', sizeList).sort(function (x, y) {
        return rank(qs('input', x).value) - rank(qs('input', y).value);
      }).forEach(function (el) { sizeList.appendChild(el); });
    }

    function readState() {
      var st = { tur: [], renk: [], beden: [], sirala: '', min: null, max: null };
      qsa('input:checked', form).forEach(function (i) {
        if (i.name === 'sirala') st.sirala = i.value;
        else if (st[i.name]) st[i.name].push(i.value);
      });
      var mn = form.elements.fiyat_min, mx = form.elements.fiyat_max;
      if (mn && mn.value !== '') st.min = parseFloat(mn.value);
      if (mx && mx.value !== '') st.max = parseFloat(mx.value);
      return st;
    }
    function matches(el, st) {
      if (st.tur.length && st.tur.indexOf(el.getAttribute('data-type')) === -1) return false;
      var colors = el.getAttribute('data-colors') || '';
      if (st.renk.length && !st.renk.some(function (c) { return colors.indexOf('|' + c + '|') !== -1; })) return false;
      var sizes = el.getAttribute('data-sizes') || '';
      if (st.beden.length && !st.beden.some(function (z) { return sizes.indexOf('|' + z + '|') !== -1; })) return false;
      var price = parseFloat(el.getAttribute('data-price'));
      if (st.min !== null && price < st.min) return false;
      if (st.max !== null && price > st.max) return false;
      return true;
    }
    function sortItems(mode) {
      var list = items.slice();
      var num = function (el, attr) { return parseFloat(el.getAttribute(attr)) || 0; };
      if (mode === 'fiyat-artan') list.sort(function (a, b) { return num(a, 'data-price') - num(b, 'data-price'); });
      else if (mode === 'fiyat-azalan') list.sort(function (a, b) { return num(b, 'data-price') - num(a, 'data-price'); });
      else if (mode === 'yeni') list.sort(function (a, b) { return num(b, 'data-created') - num(a, 'data-created'); });
      else list.sort(function (a, b) { return num(a, 'data-index') - num(b, 'data-index'); });
      list.forEach(function (el) { grid.appendChild(el); });
    }
    function writeUrl(st) {
      var url = new URL(window.location.href);
      KEYS.forEach(function (k) { if (st[k].length) url.searchParams.set(k, st[k].join(',')); else url.searchParams.delete(k); });
      if (st.sirala) url.searchParams.set('sirala', st.sirala); else url.searchParams.delete('sirala');
      if (st.min !== null || st.max !== null) url.searchParams.set('fiyat', (st.min !== null ? st.min : '') + '-' + (st.max !== null ? st.max : ''));
      else url.searchParams.delete('fiyat');
      history.replaceState(history.state, '', url.toString());
    }
    function renderChips(st) {
      if (!chips) return;
      chips.innerHTML = '';
      var add = function (label, clear) {
        var b = document.createElement('button');
        b.type = 'button';
        b.innerHTML = '<span></span><svg class="icon icon--12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M6 18 18 6M6 6l12 12"/></svg>';
        b.firstChild.textContent = label;
        on(b, 'click', function () { clear(); apply(); });
        chips.appendChild(b);
      };
      KEYS.forEach(function (k) {
        st[k].forEach(function (v) {
          add(v, function () { qsa('input[name="' + k + '"]', form).forEach(function (i) { if (i.value === v) i.checked = false; }); });
        });
      });
      if (st.min !== null || st.max !== null) {
        var money = function (v) { return formatMoney(Math.round(v * 100)).replace(/[.,]00$/, ''); };
        add(money(st.min !== null ? st.min : 0) + ' – ' + (st.max !== null ? money(st.max) : '…'), function () {
          form.elements.fiyat_min.value = ''; form.elements.fiyat_max.value = '';
        });
      }
      chips.hidden = !chips.children.length;
    }
    /* Devamı gelecek (özel dikim koleksiyonu): silüetler son sırayı tamamlar ve bir sıra daha ekler */
    var teasers = qsa('[data-teaser]', grid);
    function layoutTeasers() {
      if (!teasers.length) return;
      var cols = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length || 1;
      var shown = items.filter(function (el) { return !el.hidden; }).length;
      var need = shown ? (cols - shown % cols) % cols + cols : 0;
      teasers.forEach(function (el, i) { el.hidden = i >= need; grid.appendChild(el); });
    }
    if (teasers.length) {
      layoutTeasers();
      on(window, 'resize', debounce(layoutTeasers, 200));
    }

    function apply() {
      var st = readState();
      var shown = 0;
      var colorKey = st.renk.join('|');
      items.forEach(function (el) {
        var ok = matches(el, st);
        el.hidden = !ok;
        if (ok) shown++;
        // Renk filtresi değişince kart o rengin görselini gösterir (elle seçilen renge sıralama dokunmaz)
        if (ok && el._colorKey !== colorKey) {
          el._colorKey = colorKey;
          var card = qs('[data-card]', el);
          if (card && card._pickColor) card._pickColor(st.renk);
        }
      });
      sortItems(st.sirala);
      layoutTeasers();
      if (empty) empty.hidden = shown > 0;
      var active = st.tur.length + st.renk.length + st.beden.length + (st.min !== null || st.max !== null ? 1 : 0);
      badges.forEach(function (b) { b.textContent = active ? ' (' + active + ')' : ''; });
      if (result) result.textContent = ' (' + shown + ')';
      renderChips(st);
      writeUrl(st);
    }

    // Adres çubuğundaki seçimleri forma geri yükle
    var params = new URLSearchParams(window.location.search);
    KEYS.forEach(function (k) {
      var vals = (params.get(k) || '').split(',').filter(Boolean);
      qsa('input[name="' + k + '"]', form).forEach(function (i) { if (vals.indexOf(i.value) !== -1) i.checked = true; });
    });
    var sortParam = params.get('sirala');
    if (sortParam) qsa('input[name="sirala"]', form).forEach(function (i) { i.checked = i.value === sortParam; });
    var priceParam = (params.get('fiyat') || '').split('-');
    if (priceParam.length === 2) {
      if (priceParam[0] && form.elements.fiyat_min) form.elements.fiyat_min.value = priceParam[0];
      if (priceParam[1] && form.elements.fiyat_max) form.elements.fiyat_max.value = priceParam[1];
    }

    on(form, 'change', apply);
    on(form, 'input', debounce(function (e) { if (e.target.type === 'number') apply(); }, 350));
    on(form, 'submit', function (e) { e.preventDefault(); apply(); if (drawer) closeDrawer(drawer); });
    // Aşağı kaydırınca beliren Filtrele düğmesi: ızgaranın üst kenarı ekranın üstünü geçince iner,
    // ızgara bitince (alt bilgiye gelince) çekilir
    var fab = qs('[data-filter-fab]');
    if (fab) {
      var fabBtn = qs('button', fab);
      var fabTick = false;
      var fabUpdate = function () {
        fabTick = false;
        var r = grid.getBoundingClientRect();
        var show = r.top < 0 && r.bottom > 160;
        if (show === fab.classList.contains('is-visible')) return;
        fab.classList.toggle('is-visible', show);
        fab.setAttribute('aria-hidden', show ? 'false' : 'true');
        fabBtn.tabIndex = show ? 0 : -1;
      };
      on(window, 'scroll', function () {
        if (!fabTick) { fabTick = true; window.requestAnimationFrame(fabUpdate); }
      }, { passive: true });
      fabUpdate();
    }

    qsa('[data-filter-clear]').forEach(function (btn) {
      on(btn, 'click', function () {
        qsa('input', form).forEach(function (i) {
          if (i.type === 'checkbox') i.checked = false;
          else if (i.type === 'radio') i.checked = i.value === '';
          else i.value = '';
        });
        apply();
      });
    });
    apply();
  }

  /* ------------------------------------------------------------------
     Diğer: alt bilgi akordeonları, yukarı çık, metin belirmesi, formlar
     ------------------------------------------------------------------ */
  function initFooter() {
    qsa('[data-footer-lang]').forEach(function (select) {
      on(select, 'change', function () { if (select.form) select.form.submit(); });
    });
    var cols = qsa('[data-footer-col]');
    var mq = window.matchMedia('(min-width: 1024px)');
    function apply() { cols.forEach(function (c) { c.open = mq.matches; }); }
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
  }
  function initBackToTop() {
    var btn = qs('[data-back-to-top]');
    if (!btn) return;
    var atFooterEnd = false;
    function update() {
      btn.classList.toggle('is-visible', window.scrollY > window.innerHeight * 1.2 && !atFooterEnd);
    }
    on(btn, 'click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    window.addEventListener('scroll', debounce(update, 80), { passive: true });
    // Alt bilginin en alt satırı (Gizlilik | Şartlar) görünürken düğme o satırın üstüne binmesin
    var footerEnd = qs('.site-footer__bottom');
    if (footerEnd && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        atFooterEnd = entries[0].isIntersecting;
        update();
      }).observe(footerEnd);
    }
  }
  /* Kaydırınca belirme + parallax. html.has-motion <head>'deki betikte eklenir. */
  var motionIO = null;
  var parallaxEls = [];
  var parallaxTicking = false;
  function updateParallax() {
    parallaxTicking = false;
    var vh = window.innerHeight;
    parallaxEls.forEach(function (el) {
      if (!el._pxOn) return;
      var r = el.getBoundingClientRect();
      // -1 (ekranın üstü) … 1 (ekranın altı); görsel çerçeveden biraz yavaş akar
      var p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
      p = Math.max(-1, Math.min(1, p));
      el.style.setProperty('--py', (-p * r.height * 0.06).toFixed(1) + 'px');
    });
  }
  function scheduleParallax() {
    if (!parallaxTicking) { parallaxTicking = true; window.requestAnimationFrame(updateParallax); }
  }
  function initMotion(root) {
    if (!document.documentElement.classList.contains('has-motion')) return;
    window.__gMotion = true;
    if (!motionIO) {
      motionIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          motionIO.unobserve(entry.target);
          (entry.target._reveal || [entry.target]).forEach(function (el) {
            var show = function () {
              el.classList.add('is-in');
              // Belirme bitince sıra gecikmesini kaldır, is-done ile üzerine gelme efektleri kendi hızına geçsin
              setTimeout(function () { el.style.setProperty('--i', '0'); el.classList.add('is-done'); }, 1300);
            };
            // Görsel henüz yüklenmediyse belirmeyi yükleme bitince başlat; yarım görsel birden parlamasın
            var img = el.getAttribute('data-reveal') === 'media' && el.querySelector('img');
            if (img && !(img.complete && img.naturalWidth)) {
              var started = false;
              var go = function () { if (!started) { started = true; show(); } };
              img.addEventListener('load', go, { once: true });
              img.addEventListener('error', go, { once: true });
              if (img.loading === 'lazy') img.loading = 'eager';
              setTimeout(go, 1800);
            } else {
              show();
            }
          });
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      var pio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { entry.target._pxOn = entry.isIntersecting; });
        scheduleParallax();
      }, { rootMargin: '15% 0px' });
      motionIO._pio = pio;
      window.addEventListener('scroll', scheduleParallax, { passive: true });
      window.addEventListener('resize', scheduleParallax);
    }
    qsa('[data-reveal]', root).forEach(function (el) {
      // clip-path ile tamamen gizlenen görseller gözlemciye görünmez; bu yüzden kapsayıcıları izlenir
      var target = el.getAttribute('data-reveal') === 'media' && el.parentElement ? el.parentElement : el;
      if (target !== el) {
        target._reveal = target._reveal || [];
        target._reveal.push(el);
      }
      motionIO.observe(target);
    });
    qsa('[data-parallax]', root).forEach(function (el) {
      if (parallaxEls.indexOf(el) === -1) { parallaxEls.push(el); motionIO._pio.observe(el); }
    });
    scheduleParallax();
  }

  /* Dokunmatik ekranda üzerine gelme yok: fareyle canlanan görseller (mozaik, alt kartlar, Haftanın Kombini, menü kartları)
     kaydırma durunca ekranın ortasındaki TEK görselde aynı hâle geçer (is-odak). Kaydırırken hiçbiri canlanmaz; yan yana,
     ortaya eşit uzaklıktaki iki görselden soldaki seçilir (sahip, 14 Ekim 2026: "ortadaki tek görsel"). */
  var ODAK_SECICI = '.mosaic__tile, .image-grid--text-hover .image-grid__item--text, .image-grid--zoom a.image-grid__item, .edit-look__link, a.menu-card';
  var odakEls = [], odakEl = null, odakTop = 0, odakSaat = 0, odakKare = 0, odakKurulu = false;
  function odakBirak() {
    if (odakEl) { odakEl.classList.remove('is-odak'); odakEl = null; }
  }
  function odakSec() {
    var H = window.innerHeight, W = document.documentElement.clientWidth, cy = H / 2, cx = W / 2, bant = H * 0.15;
    var menu = qs('[data-menu-drawer].is-open');
    var secilen = null, enYakin = Infinity;
    odakEls.forEach(function (el) {
      if (!el.isConnected) return;
      // Menü açıksa yalnız menüdekiler, kapalıysa yalnız sayfadakiler
      if (menu ? !menu.contains(el) : el.closest('[data-menu-drawer]')) return;
      var r = el.getBoundingClientRect();
      if (!r.width || !r.height || r.bottom < cy - bant || r.top > cy + bant || r.right <= 0 || r.left >= W) return;
      var d = Math.hypot(r.left + r.width / 2 - cx, r.top + r.height / 2 - cy);
      if (d < enYakin - 1) { secilen = el; enYakin = d; } // eşitlikte sıradaki (soldaki) kalır
    });
    if (secilen === odakEl) return;
    odakBirak();
    if (secilen) { secilen.classList.add('is-odak'); odakEl = secilen; odakTop = secilen.getBoundingClientRect().top; }
  }
  function odakKaydir() {
    // Kaydırma sürerken odaktaki görsel yerinden belirgin oynarsa bırakılır; kaydırma durunca (150 ms) ortadaki seçilir
    if (odakEl && !odakKare) {
      odakKare = requestAnimationFrame(function () {
        odakKare = 0;
        if (odakEl && Math.abs(odakEl.getBoundingClientRect().top - odakTop) > window.innerHeight * 0.08) odakBirak();
      });
    }
    clearTimeout(odakSaat);
    odakSaat = setTimeout(odakSec, 150);
  }
  function initTouchFocus(root) {
    if (!window.matchMedia || !window.matchMedia('(hover: none)').matches) return;
    qsa(ODAK_SECICI, root).forEach(function (el) {
      if (odakEls.indexOf(el) === -1) odakEls.push(el);
    });
    if (odakKurulu) return;
    odakKurulu = true;
    // capture: sayfanın yanı sıra menü çekmecesi gibi iç kaydırıcıları da duyar
    document.addEventListener('scroll', odakKaydir, { capture: true, passive: true });
    on(window, 'resize', odakKaydir);
    odakKaydir();
  }

  /* Vitrin (telefon): ilerleme çizgisi + liste ekrana ilk gelince bir kez hafif kayıp dönme ipucu */
  function initVitrin(root) {
    qsa('.stl__list', root).forEach(function (list) {
      if (list._vitrin) return;
      list._vitrin = true;
      var bar = list.parentNode.querySelector('[data-stl-bar]');
      var fill = bar && bar.querySelector('span');
      function update() {
        if (!bar) return;
        var max = list.scrollWidth - list.clientWidth;
        bar.classList.toggle('is-on', max > 2 && getComputedStyle(list).overflowX !== 'visible');
        if (max <= 2) return;
        var w = list.clientWidth / list.scrollWidth;
        fill.style.width = (w * 100) + '%';
        fill.style.left = ((list.scrollLeft / max) * (1 - w) * 100) + '%';
      }
      on(list, 'scroll', update, { passive: true });
      on(window, 'resize', update);
      update();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) return;
      var touched = false;
      on(list, 'pointerdown', function () { touched = true; }, { passive: true });
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        if (touched || list.scrollLeft > 0 || list.scrollWidth - list.clientWidth <= 2) return;
        var snap = list.style.scrollSnapType;
        list.style.scrollSnapType = 'none';
        setTimeout(function () {
          list.scrollTo({ left: Math.min(56, list.scrollWidth - list.clientWidth), behavior: 'smooth' });
          setTimeout(function () {
            list.scrollTo({ left: 0, behavior: 'smooth' });
            setTimeout(function () { list.style.scrollSnapType = snap; }, 700);
          }, 650);
        }, 350);
      }, { threshold: 0.6 });
      io.observe(list);
    });
  }

  /* Ürün sayfası: "Teslimat & Değişim" bağlantısı sayfanın altındaki hizmetler bandına yumuşakça kaydırır
     (bandın kendi üst boşluğu sabit menünün altında kalır, ek pay gerekmez) */
  on(document, 'click', function (e) {
    var link = e.target.closest && e.target.closest('[data-hzm-link]');
    if (!link) return;
    var hedef = document.getElementById('teslimat-degisim');
    if (!hedef) return;
    e.preventDefault();
    var sakin = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    hedef.scrollIntoView({ behavior: sakin ? 'auto' : 'smooth', block: 'start' });
  });

  function init() {
    initHeader();
    initMenu();
    initSearch();
    initCart();
    initWishlist();
    initCards(document);
    initQuickAdd();
    initProduct();
    initCarousels(document);
    initRecommendations();
    initCollection();
    initFooter();
    initBackToTop();
    initMotion(document);
    initDetails(document);
    initTouchFocus(document);
    initVitrin(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Tema düzenleyicide bölüm yeniden yüklenince
  document.addEventListener('shopify:section:load', function (e) {
    initMotion(e.target);
    initCards(e.target);
    initCarousels(e.target);
    initTouchFocus(e.target);
    initVitrin(e.target);
    syncWishlistButtons(e.target);
  });
})();
